import { createI18n, resolveLocale } from "@t3tools/shared/i18n";

const fallbackMessages = {
  "thread.localImageUnavailable":
    "This image is stored on your computer and cannot be previewed here yet.",
  "common.close": "Close",
  "common.back": "Back",
  "common.cancel": "Cancel",
  "common.continue": "Continue",
  "common.delete": "Delete",
  "common.next": "Next",
  "common.search": "Search",
  "common.submit": "Submit",
  "common.tryAgain": "Try again",
  "markdown.mermaid.rendering": "Rendering diagram",
  "markdown.mermaid.renderError": "Mermaid diagram could not be rendered. Showing source.",
  "markdown.mermaid.expand": "Expand diagram",
  "markdown.mermaid.viewerTitle": "Mermaid diagram",
  "markdown.mermaid.zoomOut": "Zoom out",
  "markdown.mermaid.zoomIn": "Zoom in",
  "markdown.mermaid.fit": "Fit diagram",
  "sidebar.status.working": "Working",
  "sidebar.status.approval": "Approval",
  "sidebar.status.input": "Input",
  "sidebar.status.failed": "Failed",
  "sidebar.status.woke": "Woke",
  "sidebar.status.done": "Done",
  "sidebar.status.deleting": "Deleting",
  "sidebar.search": "Search threads and commands",
  "sidebar.newThread": "New thread",
  "sidebar.newThreadWithShortcut": "New thread ({shortcut})",
  "sidebar.newThreadInProject": "New thread in {project}",
  "sidebar.goToThreads": "Go to threads",
  "sidebar.newProject": "New project",
  "sidebar.allProjects": "All projects",
  "sidebar.snoozed": "Snoozed",
  "sidebar.snoozedCount": "Snoozed ({count})",
  "sidebar.settled": "Settled",
  "sidebar.settledCount": "Settled ({count})",
  "sidebar.showMore": "Show {count} more",
  "sidebar.noProjects": "No projects yet",
  "sidebar.noThreads": "No threads yet",
  "sidebar.noThreadsInProject": "No threads in {project} yet",
  "sidebar.newThreadOnBranch": "New thread on {branch}",
  "sidebar.settle": "Complete",
  "sidebar.unsettle": "Restore",
  "sidebar.settleThread": "Settle thread",
  "sidebar.unsettleThread": "Un-settle thread",
  "sidebar.snoozeThread": "Snooze thread",
  "sidebar.wakeThread": "Wake thread",
  "sidebar.renameThread": "Rename thread",
  "sidebar.markUnread": "Mark unread",
  "sidebar.copyPath": "Copy path",
  "sidebar.copyThreadId": "Copy thread ID",
  "sidebar.actionCount.settle": "Settle ({count})",
  "sidebar.actionCount.snooze": "Snooze ({count})",
  "sidebar.actionCount.markUnread": "Mark unread ({count})",
  "sidebar.actionCount.delete": "Delete ({count})",
  "sidebar.addProject": "Add project",
  "sidebar.projectSettings": "Project settings",
  "sidebar.renameProject": "Rename",
  "sidebar.groupProject": "Group into...",
  "sidebar.removeProject": "Remove",
  "sidebar.copyProjectPath": "Copy project path",
  "sidebar.projectName": "Project name",
  "sidebar.groupingRule": "Grouping rule",
  "sidebar.currentEnvironment": "current environment",
  "providerImport.title": "Import provider conversation",
  "providerImport.description": "Choose an existing conversation for {project}.",
  "providerImport.projectUnavailable": "Choose a project before importing a conversation.",
  "providerImport.providers": "Providers",
  "providerImport.search": "Search conversations…",
  "providerImport.sort.recent": "Recent",
  "providerImport.sort.oldest": "Oldest",
  "providerImport.timeFilter": "Filter by last activity",
  "providerImport.time.all": "Any time",
  "providerImport.time.7d": "7 days",
  "providerImport.time.30d": "30 days",
  "providerImport.time.90d": "90 days",
  "providerImport.refresh": "Refresh conversations",
  "providerImport.loading": "Loading conversations…",
  "providerImport.loadMore": "Load more",
  "providerImport.loadingMore": "Loading more…",
  "providerImport.empty": "No conversations are available for this project.",
  "providerImport.noMatches": "No conversations match your search.",
  "providerImport.noProviders": "No configured Provider supports conversation import.",
  "providerImport.unavailable.unsupported": "This Provider does not support conversation import.",
  "providerImport.unavailable.configurationConflict":
    "Conversation import is unavailable because multiple enabled Provider instances use the same session store.",
  "providerImport.status.available": "Available",
  "providerImport.status.busy": "Busy",
  "providerImport.status.activityUnknown": "Status unknown",
  "providerImport.status.alreadyImported": "Already imported",
  "providerImport.status.archived": "Archived",
  "providerImport.status.deleting": "Deleting",
  "providerImport.confirmStopped":
    "So Code cannot verify external activity. I confirm that all other Provider clients using this conversation are stopped.",
  "providerImport.directBindWarning":
    "Direct bind transfers ownership of the original Provider conversation to this task. Do not use it concurrently elsewhere. Deleting this task also permanently deletes the original conversation.",
  "providerImport.noModel": "This Provider has no model available for the imported task.",
  "providerImport.failed": "Could not import the Provider conversation.",
  "providerImport.error.project-not-found": "This project is no longer available.",
  "providerImport.error.provider-unavailable": "This Provider is unavailable.",
  "providerImport.error.import-unsupported": "This Provider does not support conversation import.",
  "providerImport.error.configuration-conflict":
    "Conversation import is unavailable because the Provider configuration conflicts.",
  "providerImport.error.candidate-invalid":
    "This conversation selection is invalid. Refresh the list and try again.",
  "providerImport.error.candidate-stale":
    "This conversation selection has expired. Refresh the list and try again.",
  "providerImport.error.session-unavailable": "This Provider conversation is no longer available.",
  "providerImport.error.session-busy": "This Provider conversation is currently active elsewhere.",
  "providerImport.error.confirmation-required":
    "Confirm that all other Provider clients using this conversation are stopped.",
  "providerImport.error.deleting-conflict": "The imported task is currently being deleted.",
  "providerImport.error.history-unavailable": "The Provider conversation history is unavailable.",
  "providerImport.error.persistence-failed": "Could not save the imported conversation.",
  "providerImport.import": "Import conversation",
  "providerImport.importing": "Importing…",
  "composer.submitting": "Submitting...",
  "composer.submit": "Submit",
  "composer.next": "Next",
  "composer.nextQuestion": "Next question",
  "composer.submitAnswers": {
    one: "Submit answer",
    other: "Submit answers",
  },
  "composer.previousQuestion": "Previous question",
  "composer.previous": "Previous",
  "composer.stopGeneration": "Stop generation",
  "composer.sending": "Sending...",
  "composer.refine": "Refine",
  "composer.implement": "Implement",
  "composer.implementationActions": "Implementation actions",
  "composer.implementNewThread": "Implement in a new thread",
  "composer.environmentDisconnected": "Environment disconnected",
  "composer.connecting": "Connecting",
  "composer.preparingWorktree": "Preparing worktree",
  "composer.sendMessage": "Send message",
  "composer.queueMessage": "Queue message",
  "composer.queueLabel": "Queued messages",
  "composer.queueCount": {
    one: "1 queued message",
    other: "{count} queued messages",
  },
  "composer.queueAttachmentOnly": "Image attachment",
  "composer.queueDispatching": "Sending...",
  "composer.queueSteering": "Steering...",
  "composer.queueEdit": "Edit queued message",
  "composer.queueDelete": "Delete queued message",
  "composer.queueSteer": "Steer with queued message",
  "composer.queueSaveEdit": "Save queued message",
  "composer.queueCancelEdit": "Cancel editing queued message",
  "composer.queueEditFailed": "Failed to update queued message.",
  "composer.queueDeleteFailed": "Failed to delete queued message.",
  "composer.queueSteerFailed": "Failed to steer with queued message.",
  "composer.runtimeMode": "Runtime mode",
  "composer.runtime.supervised": "Supervised",
  "composer.runtime.supervisedDescription": "Ask before commands and file changes.",
  "composer.runtime.autoAccept": "Auto-accept edits",
  "composer.runtime.autoAcceptDescription": "Auto-approve edits, ask before other actions.",
  "composer.runtime.auto": "Auto",
  "composer.runtime.autoDescription":
    "An AI reviewer approves routine actions; risky ones still ask.",
  "composer.runtime.fullAccess": "Full access",
  "composer.runtime.fullAccessDescription": "Allow commands and edits without prompts.",
  "composer.runtimeLockedAfterStart": "Agent runtime is fixed after this thread starts.",
  "composer.runProviderCommand": "Run provider command",
  "composer.scopedSkill": "{scope} skill",
  "composer.runProviderSkill": "Run provider skill",
  "composer.skills": "Skills",
  "composer.builtIn": "Built-in",
  "composer.provider": "Provider",
  "composer.searchingSkills": "Searching workspace skills...",
  "composer.noSkills": "No skills found. Try / to browse provider commands.",
  "composer.searchingFiles": "Searching workspace files...",
  "composer.noMatchingFiles": "No matching files or folders.",
  "composer.noMatchingCommand": "No matching command.",
  "contextWindow.title": "Context window",
  "contextWindow.tokensUsed": "{tokens} tokens used",
  "contextWindow.totalProcessed": "Total processed",
  "contextWindow.autoCompacts": "{provider} automatically compacts its context when needed.",
  "contextWindow.autoCompactsFallback": "Context is automatically compacted when needed.",
  "contextWindow.status.healthy": "healthy",
  "contextWindow.status.warning": "high usage",
  "contextWindow.status.critical": "near the limit",
  "contextWindow.aria.percentageUsed": "Context window: {percentage} used, {status}",
  "contextWindow.aria.tokensUsed": "Context window: {tokens} tokens used",
  "composer.planModeTooltip": "Plan mode — click to return to normal build mode",
  "composer.buildModeTooltip": "Default mode — click to enter plan mode",
  "composer.hideSidebar": "Hide {label} sidebar",
  "composer.showSidebar": "Show {label} sidebar",
  "composer.plan": "Plan",
  "composer.build": "Build",
  "tasks.progress": "Step {current} / {total}",
  "tasks.expand": "Expand task list",
  "tasks.collapse": "Collapse task list",
  "tasks.status.pending": "Pending",
  "tasks.status.inProgress": "In progress",
  "tasks.status.completed": "Completed",
  "tasks.accessibility.summary": "Task progress, {progress}",
  "tasks.accessibility.step": "{step}, {status}",
  "activityGroup.count": {
    one: "{count} activity",
    other: "{count} activities",
  },
  "activityGroup.toolCalls": {
    one: "{count} tool call",
    other: "{count} tool calls",
  },
  "activityGroup.expand": "Show activity details: {summary}",
  "activityGroup.collapse": "Hide activity details: {summary}",
  "activityGroup.workLog": "Work Log",
  "activityGroup.reasoning": "Reasoning process",
  "activityGroup.reasoningInProgress": "Thinking…",
  "activityGroup.toolDetailTruncated": "Tool detail was truncated to the preview limit.",
  "activityGroup.current.command": "Running command",
  "activityGroup.current.fileRead": "Reading files",
  "activityGroup.current.fileSearch": "Searching files",
  "activityGroup.current.fileChange": "Editing files",
  "activityGroup.current.webSearch": "Searching the web",
  "activityGroup.summary.mcpTools": {
    one: "Used {count} MCP tool",
    other: "Used {count} MCP tools",
  },
  "activityGroup.summary.readFiles": {
    one: "Read {count} file",
    other: "Read {count} files",
  },
  "activityGroup.summary.fileSearches": {
    one: "Performed {count} file search",
    other: "Performed {count} file searches",
  },
  "activityGroup.summary.changedFiles": {
    one: "Changed {count} file",
    other: "Changed {count} files",
  },
  "activityGroup.summary.commands": {
    one: "Ran {count} command",
    other: "Ran {count} commands",
  },
  "activityGroup.summary.webSearches": {
    one: "Performed {count} Web search",
    other: "Performed {count} Web searches",
  },
  "activityGroup.summary.otherTools": {
    one: "Used {count} other tool",
    other: "Used {count} other tools",
  },
  "activityGroup.summary.separator": ", ",
  "plan.sidebar.title": "Plan",
  "plan.sidebar.actions": "Plan actions",
  "plan.sidebar.copied": "Copied!",
  "plan.sidebar.copyMarkdown": "Copy Plan Mode Markdown",
  "plan.sidebar.downloadMarkdown": "Download Plan Mode Markdown",
  "plan.sidebar.saveMarkdown": "Save Plan Mode Markdown to workspace",
  "plan.sidebar.proposal": "Plan Mode proposal",
  "plan.sidebar.emptyTitle": "No proposed plan yet.",
  "plan.sidebar.emptyDescription": "Plan Mode Markdown will appear here when generated.",
  "plan.sidebar.saved": "Plan saved",
  "plan.sidebar.saveFailed": "Could not save plan",
  "composer.switchResponseModel": "Switch response model for this thread",
  "composer.switchToPlanMode": "Switch this thread into plan mode",
  "composer.switchToBuildMode": "Switch this thread back to normal build mode",
  "composer.writeCustomAnswer": "Write custom answer",
  "composer.expand": "Expand composer",
  "composer.customAnswerPlaceholder":
    "Type your own answer, or leave this blank to use the selected option",
  "composer.enableProvider": "Enable a provider in Settings",
  "composer.askAnythingShort": "Ask anything…",
  "composer.resolveApproval": "Resolve this approval request to continue",
  "composer.planFeedbackPlaceholder":
    "Add feedback to refine the plan, or leave this blank to implement it",
  "composer.chooseProjectPlaceholder": "Choose a project above to start a thread",
  "composer.enableProviderToSend": "Enable a provider in Settings to send a message",
  "composer.disconnectedPlaceholder": "Ask for follow-up changes or attach images",
  "composer.defaultPlaceholder": "Ask anything, @tag files/folders, $use skills, or / for commands",
  "composer.stashRestoreMayReappear": "Restored prompt may reappear in the stash",
  "composer.stashRestoreMayReappearDescription":
    "Browser storage rejected the update, so this entry could still be there after a reload.",
  "composer.stashImagesTooLarge":
    "{names} exceeded the stash size limit when this prompt was saved.",
  "composer.stashImagesUnreadable": "{names} could not be read when this prompt was saved.",
  "composer.stashImagesOverLimit":
    "{names} could not be restored because the composer is at its {count}-image limit.",
  "composer.someImagesNotRestored": "Some images were not restored",
  "composer.stashEntryMayReturn": "Stash entry may come back",
  "composer.stashEntryMayReturnDescription":
    "Browser storage rejected the delete, so this prompt could reappear after a reload.",
  "composer.stashFailed": "Could not stash this prompt",
  "composer.stashFailedDescription":
    "Browser storage rejected the write, so the composer was left as-is. Free up site data and try again.",
  "composer.stashSessionOnly": "Stashed prompt will not survive a reload",
  "composer.stashSessionOnlyDescription":
    "Browser storage is unavailable, so this stash is kept in memory only for this session.",
  "composer.oldestStashDiscarded": "Oldest stashed prompt discarded",
  "composer.oldestStashDiscardedDescription":
    "The stash holds {count} prompts; the oldest was removed to make room.",
  "composer.stashImagesNotSaved": "Stashed images were not saved",
  "composer.stashImagesNotSavedDescription":
    "The prompt was stashed, but browser storage rejected its images. They will be missing if you reload.",
  "composer.stashImagesNotAttached": "Stashed images did not attach",
  "composer.stashImagesNotAttachedDescription":
    "The prompt was restored or deleted before {count} images finished saving. Re-attach them if needed.",
  "composer.answerPlanBeforeImages": "Attach images after answering plan questions.",
  "composer.unsupportedAttachment":
    "Unsupported file type for '{name}'. Please attach image files only.",
  "composer.attachmentTooLarge": "'{name}' exceeds the {limit} attachment limit.",
  "composer.attachmentCountLimit": "You can attach up to {count} images per message.",
  "composer.addToChatFailed": "Unable to add to chat",
  "composer.busyTryAgain": "The composer is busy; try again once it is ready.",
  "composer.previewImage": "Preview {name}",
  "composer.attachmentMayNotPersist": "Draft attachment may not persist",
  "composer.attachmentMayNotPersistDescription":
    "Draft attachment could not be saved locally and may be lost on navigation.",
  "composer.removeImage": "Remove {name}",
  "draft.changeProject": "Change project",
  "draft.chooseProject": "Choose a project",
  "draft.newProject": "New project",
  "draft.addProject": "Add a project",
  "draft.whatBuildPrefix": "What should we build in ",
  "draft.whatBuildSuffix": "?",
  "draft.chooseProjectToStartSuffix": " to start",
  "draft.addProjectToStart": "Add a project to start",
  "approval.pending": "PENDING APPROVAL",
  "approval.commandRequested": "Command approval requested",
  "approval.fileReadRequested": "File-read approval requested",
  "approval.fileChangeRequested": "File-change approval requested",
  "approval.command": "Command",
  "approval.fileToRead": "File to read",
  "approval.fileChange": "File change",
  "chat.reconnectFailed": "Could not reconnect environment",
  "chat.reconnectFailedFallback": "Failed to reconnect.",
  "chat.versionMismatch": "Client and server versions differ",
  "chat.versionMismatchDescription": "Client {client} is connected to {serverLabel} {server}",
  "chat.deletedAction": 'Deleted action "{name}"',
  "chat.unknown": "Unknown",
  "chat.deleteActionFailed": "Could not delete action",
  "chat.unexpectedError": "An unexpected error occurred.",
  "chat.copyPathFailed": "Failed to copy path",
  "chat.clipboardUnavailable": "Clipboard API unavailable.",
  "chat.pathCopied": "Path copied",
  "chat.unsettleFailed": "Failed to un-settle thread",
  "chat.wakeFailed": "Failed to wake thread",
  "chat.switchCheckoutFailed": "Failed to switch checkout",
  "chat.checkoutThreadUpdateFailed": "Checkout switched, but the thread could not be updated",
  "chat.chooseProject": "Choose a project first",
  "chat.projectUnavailable": "This draft no longer points to an available project.",
  "chat.implementationThreadStartFailed": "Could not start implementation thread",
  "timeline.status.connecting": "Connecting",
  "timeline.native.subtaskRequest": "Subtask for {agent}: {description}",
  "timeline.native.agentReference": "Agent reference: {agent}",
  "timeline.native.retryAttempt": "Retrying provider request (attempt {attempt})",
  "timeline.native.retryNext": "Next attempt at {time}",
  "timeline.native.contextCompacted": "Context compacted",
  "timeline.native.contextCompactedAutomatic": "Context compacted automatically",
  "timeline.native.contextCompactedOverflow": "Context compacted after reaching the limit",
  "timeline.native.filesChanged": {
    one: "Changed {count} file",
    other: "Changed {count} files",
  },
  "chat.scrollToEnd": "Scroll to end",
  "chat.branchChangedWas": "Branch changed — was",
  "chat.errorOccurred": "An error occurred.",
  "chat.reconnectBeforeSending":
    "Reconnect this environment before sending messages or running actions.",
  "chat.reconnecting": "Reconnecting...",
  "chat.reconnect": "Reconnect",
  "chat.connections": "Connections",
  "liveSubagents.liveSubagents": "Live subagents",
  "liveSubagents.rosterLabel": "Live subagent roster",
  "liveSubagents.agentCountOne": "{count} agent",
  "liveSubagents.agentCountOther": "{count} agents",
  "liveSubagents.openAgent": "Open {name}, {status}, in Agents",
  "liveSubagents.agentFallback": "Agent",
  "liveSubagents.dock.agents": "Agents {count}",
  "liveSubagents.dock.running": "{count} running",
  "liveSubagents.dock.attention": "{count} needs attention",
  "liveSubagents.dock.attentionSuffix": ", {attention}",
  "liveSubagents.dock.open": "Open Agents: {agents}, {running}{attention}",
  "liveSubagents.connecting": "Connecting to live agents…",
  "liveSubagents.loadingActivity": "Loading live activity…",
  "liveSubagents.truncationNotice":
    "Earlier live activity was removed to keep this view responsive.",
  "liveSubagents.empty": "No live subagents",
  "liveSubagents.runtimeEnded": "Runtime ended",
  "liveSubagents.runtimeEndedDescription":
    "This live view expired when the provider runtime stopped.",
  "liveSubagents.agentsUnavailable": "Agents unavailable",
  "liveSubagents.transportError": "Live agents could not be loaded",
  "liveSubagents.status.pending": "Pending",
  "liveSubagents.status.running": "Running",
  "liveSubagents.status.waiting": "Waiting",
  "liveSubagents.status.completed": "Completed",
  "liveSubagents.status.failed": "Failed",
  "liveSubagents.status.stopped": "Stopped",
  "liveSubagents.model": "Model: {model}",
  "liveSubagents.reasoningEffort": "Reasoning: {effort}",
  "liveSubagents.reasoningEffort.minimal": "Minimal",
  "liveSubagents.reasoningEffort.low": "Low",
  "liveSubagents.reasoningEffort.medium": "Medium",
  "liveSubagents.reasoningEffort.high": "High",
  "liveSubagents.reasoningEffort.xhigh": "Extra high",
  "liveSubagents.reasoningEffort.max": "Max",
  "liveSubagents.emptyActivity": "No activity yet.",
  "liveSubagents.activityUnavailable":
    "This provider exposes live agent status, but not activity details.",
  "liveSubagents.lifecycleOnly": "This provider exposes lifecycle activity only.",
  "liveSubagents.lifecycle.started": "Agent started",
  "liveSubagents.lifecycle.running": "Agent running",
  "liveSubagents.lifecycle.waiting": "Agent waiting",
  "liveSubagents.lifecycle.resumed": "Agent resumed",
  "liveSubagents.lifecycle.completed": "Agent completed",
  "liveSubagents.lifecycle.failed": "Agent failed",
  "liveSubagents.lifecycle.stopped": "Agent stopped",
  "liveSubagents.reasoning": "Reasoning",
  "liveSubagents.tool.call": "Tool call",
  "liveSubagents.tool.input": "Input",
  "liveSubagents.tool.output": "Output",
  "liveSubagents.tool.error": "Error",
  "liveSubagents.unavailable.unsupported": "This provider runtime does not expose live subagents.",
  "liveSubagents.unavailable.runtimeNotLive": "The provider runtime is no longer live.",
  "liveSubagents.unavailable.timedOut":
    "The provider did not answer the observation request in time.",
  "liveSubagents.unavailable.transport":
    "The live activity connection to the provider was interrupted.",
  "liveSubagents.unavailable.malformed":
    "The provider returned observation data this client could not read.",
  "liveSubagents.unavailable.rejected": "The provider rejected the live observation request.",
  "liveSubagents.unavailable.default": "Live subagent observation is unavailable.",
  "threadSummary.summary": "Summary",
  "threadSummary.open": "Open thread summary",
  "threadSummary.environment": "Environment information",
  "threadSummary.sourceControl": "Source control",
  "threadSummary.machine": "Run on",
  "threadSummary.workspace": "Workspace",
  "threadSummary.path": "Path",
  "threadSummary.branch": "Branch",
  "threadSummary.changes": "Changes",
  "threadSummary.locked": "Locked",
  "threadSummary.workspaceLockedDescription":
    "The workspace cannot be changed after the thread starts.",
  "threadSummary.loadingStatus": "Loading status…",
  "threadSummary.statusUnavailable": "Status unavailable",
  "threadSummary.notRepository": "Not a Git repository",
  "threadSummary.noChanges": "No changes",
  "threadSummary.diffAvailableAfterStart": "Diff is available after the thread starts.",
  "threadSummary.detachedHead": "Detached HEAD: no branch is currently checked out.",
  "threadSummary.branchMismatch":
    "Thread expects {threadBranch}; the current checkout is {currentBranch}.",
  "threadSummary.changesCount": "{additions} additions, {deletions} deletions",
  "threadSummary.openChanges": "Open changes in Diff: {additions} additions, {deletions} deletions",
  "chat.runScriptFailed": 'Failed to run script "{name}".',
  "chat.scriptNotFound": "Script not found.",
  "chat.threadSnoozed": "This thread is snoozed",
  "chat.threadSettled": "This thread is settled",
  "chat.snoozedDescription":
    "Sending a message wakes it and moves it back to Active in the sidebar.",
  "chat.settledDescription": "Sending a message moves it back to Active in the sidebar.",
  "chat.waking": "Waking...",
  "chat.wakeNow": "Wake now",
  "chat.unsettling": "Un-settling...",
  "chat.unsettle": "Un-settle",
  "chat.restoring": "Restoring...",
  "chat.restoreBranch": "Restore branch",
  "chat.dismissBranchNotice": "Dismiss branch change notice",
  "chat.reconnectBeforeRevert": "Reconnect {environment} before reverting checkpoints.",
  "chat.interruptBeforeRevert": "Interrupt the current turn before reverting checkpoints.",
  "chat.revertConfirm":
    "Restore the workspace to checkpoint {count}?\nProvider conversation history will not be changed.",
  "chat.revertToCheckpoint": "Restore workspace checkpoint",
  "chat.noActiveProjectForChangeRequest": "No active project is available for this change request.",
  "chat.serverPreviewLoadFailed": "Failed to load server preview for {messageId}.",
  "chat.revertFailed": "Failed to revert thread state.",
  "chat.revertRefreshFailed": "Workspace restored, but refresh failed.",
  "chat.selectBaseBranch": "Select a base branch before sending in New worktree mode.",
  "chat.sendFailed": "Failed to send message.",
  "chat.sendOutcomeUnknown":
    "The send result is unknown. The Provider may have received it. Check the task history before resending to avoid a duplicate.",
  "chat.historyUnavailable":
    "The Provider history is temporarily unavailable. Reopen or refresh the task to try again.",
  "chat.providerUnavailable": "This Provider is unavailable for Native tasks.",
  "chat.nativeImageMimeUnsupported": "Claude Native does not support this image format.",
  "chat.interruptFailed": "Failed to interrupt the current turn.",
  "chat.approvalSubmitFailed": "Failed to submit approval decision.",
  "chat.inputSubmitFailed": "Failed to submit user input.",
  "chat.planFollowUpFailed": "Failed to send plan follow-up.",
  "chat.implementationCreateFailed": "An error occurred while creating the new thread.",
  "chat.switchBranchDescription":
    "You have uncommitted changes. They'll carry over to the other branch, or block the switch if they conflict.",
  "chat.switchBranch": "Switch branch",
  "root.showErrorDetails": "Show error details",
  "root.hideErrorDetails": "Hide error details",
  "root.keybindingsUpdated": "Keybindings updated",
  "root.keybindingsReloaded": "Keybindings configuration reloaded successfully.",
  "root.keybindingsInvalid": "Invalid keybindings configuration",
  "root.openKeybindings": "Open keybindings.json",
  "root.openKeybindingsFailed": "Unable to open keybindings file",
  "root.unexpectedRouterError": "An unexpected router error occurred.",
  "root.noAdditionalErrorDetails": "No additional error details are available.",
  "root.unknownFileOpenError": "Unknown error opening file.",
  "git.publishRepository": "Publish repository",
  "git.publishFailed": "Publish failed",
  "git.remote": "Remote",
  "git.private": "Private",
  "git.privateDescription": "Only invited people",
  "git.public": "Public",
  "git.publicDescription": "Anyone on the web",
  "git.linkUnavailable": "Link opening is unavailable.",
  "git.noOpenPullRequest": "No open pull request found.",
  "git.openPullRequestFailed": "Unable to open pull request link",
  "git.waitingForGit": "Waiting for Git...",
  "git.actionFailed": "Action failed",
  "git.pulling": "Pulling...",
  "git.pullFailed": "Pull failed",
  "git.editorUnavailable": "Editor opening is unavailable.",
  "git.openFileFailed": "Unable to open file",
  "git.initializationFailed": "Git initialization failed",
  "git.actions": "Git actions",
  "git.options": "Git action options",
  "git.branch": "Branch",
  "git.defaultRefWarning": "Warning: default refName",
  "git.files": "Files",
  "git.none": "none",
  "git.excluded": "Excluded",
  "git.commitMessageOptional": "Commit message (optional)",
  "git.commitMessagePlaceholder": "Leave empty to auto-generate",
  "git.providerStatusUnavailable":
    "Provider status unavailable. Open Settings → Source Control and rescan.",
  "git.providerNotAuthenticated":
    "{provider} is not authenticated. Open Settings → Source Control for setup guidance.",
  "git.runningSeconds": "Running for {seconds}s",
  "git.runningMinutes": "Running for {minutes}m {seconds}s",
  "git.actionInProgress": "Git action in progress.",
  "git.statusUnavailable": "Git status is unavailable.",
  "git.cleanWorktree": "Worktree is clean. Make changes before committing.",
  "git.commitUnavailable": "Commit is currently unavailable.",
  "git.detachedBeforePush": "Detached HEAD: checkout a refName before pushing.",
  "git.commitOrStash": "Commit or stash local changes before pushing.",
  "git.behindBeforePush": "Branch is behind upstream. Pull or rebase before pushing.",
  "git.addOriginBeforePush": 'Add an "origin" remote before pushing.',
  "git.noCommitsToPush": "No local commits to push.",
  "git.pushUnavailable": "Push is currently unavailable.",
  "git.viewChangeRequestUnavailable": "View {name} is currently unavailable.",
  "git.detachedBeforeChangeRequest": "Detached HEAD: checkout a refName before creating a {name}.",
  "git.commitBeforeChangeRequest": "Commit local changes before creating a {name}.",
  "git.addOriginBeforeChangeRequest": 'Add an "origin" remote before creating a {name}.',
  "git.noCommitsForChangeRequest": "No local commits to include in a {name}.",
  "git.behindBeforeChangeRequest":
    "Branch is behind upstream. Pull or rebase before creating a {name}.",
  "git.createChangeRequestUnavailable": "Create {name} is currently unavailable.",
  "git.commitChanges": "Commit changes",
  "git.commitDialogDescription":
    "Review and confirm your commit. Leave the message blank to auto-generate one.",
  "git.setupRequired": "Setup required",
  "git.configureProvider": "Open Settings → Source Control to configure this provider.",
  "git.repositoryPublished": "Repository published",
  "git.repositoryCreated": "Repository created",
  "git.branchLive": "{branch} is now live on {provider}.",
  "git.remoteReady": 'Remote "{remote}" is set up. Make a commit and push it to share your code.',
  "git.actionUnavailable": "This action is currently unavailable.",
  "git.runningAction": "Running Git action…",
  "git.runningHook": "Running {hook}…",
  "git.committing": "Committing…",
  "git.pulled": "Pulled",
  "git.alreadyUpToDate": "Already up to date",
  "git.updatedFrom": "Updated {ref} from {upstream}",
  "git.alreadySynchronized": "{ref} is already synchronized.",
  "git.initializing": "Initializing…",
  "git.initialize": "Initialize Git",
  "git.runOnDefaultRef": "Run action on default refName?",
  "git.commit": "Commit",
  "git.push": "Push",
  "git.commitAndPush": "Commit & push",
  "git.syncRef": "Sync ref",
  "git.pull": "Pull",
  "git.branchDiverged": "Branch has diverged from upstream. Rebase or merge first.",
  "git.branchUpToDate": "Branch is up to date. No action needed.",
  "git.preparingFeatureRef": "Preparing feature ref…",
  "git.pushing": "Pushing…",
  "git.generatingCommitMessage": "Generating commit message…",
  "git.pullRequest": "pull request",
  "git.mergeRequest": "merge request",
  "git.changeRequest": "change request",
  "git.viewName": "View {name}",
  "git.createName": "Create {name}",
  "git.commitPushAndName": "Commit, push & {name}",
  "git.commitPushCreateName": "Commit, push & create {name}",
  "git.pushCreateName": "Push & create {name}",
  "git.pushingTo": "Pushing to {target}…",
  "git.preparingName": "Preparing {name}…",
  "git.generatingNameContent": "Generating {name} content…",
  "git.creatingName": "Creating {name}…",
  "git.createRefFirst": "Create and checkout a ref before pushing or opening a {name}.",
  "git.commitPushTo": "Commit & push to {branch}",
  "git.pushTo": "Push to {branch}",
  "git.commitPushDefaultTitle": "Commit & push to default ref?",
  "git.pushDefaultTitle": "Push to default ref?",
  "git.commitPushCreateDefaultTitle": "Commit, push & create {name} from default ref?",
  "git.pushCreateDefaultTitle": "Push & create {name} from default ref?",
  "git.commitPushDefaultDescription":
    'This action will commit and push changes on "{branch}". You can continue on this ref or create a feature ref and run the same action there.',
  "git.pushDefaultDescription":
    'This action will push local commits on "{branch}". You can continue on this ref or create a feature ref and run the same action there.',
  "git.commitPushCreateDefaultDescription":
    'This action will commit, push, and create a {name} on "{branch}". You can continue on this ref or create a feature ref and run the same action there.',
  "git.pushCreateDefaultDescription":
    'This action will push local commits and create a {name} on "{branch}". You can continue on this ref or create a feature ref and run the same action there.',
  "palette.ariaLabel": "Command palette",
  "palette.searchAll": "Search commands, projects, and threads...",
  "palette.search": "Search...",
  "palette.projects": "Projects",
  "palette.threads": "Threads",
  "palette.directories": "Directories",
  "palette.actions": "Actions",
  "palette.recentThreads": "Recent Threads",
  "palette.environments": "Environments",
  "palette.sources": "Sources",
  "palette.selectCloneDestination": "Select where to clone",
  "palette.noActions": "No matching actions.",
  "palette.noResults": "No matching commands, projects, or threads.",
  "palette.unableToBrowseProjects": "Unable to browse projects",
  "palette.noEnvironmentAvailable": "No environment is available.",
  "palette.newThreadIn": "New thread in {project}",
  "palette.newThreadInEllipsis": "New thread in...",
  "palette.addProject": "Add project",
  "palette.openWslFolder": "Open WSL folder",
  "palette.createAndClone": "Create & Clone",
  "palette.clone": "Clone",
  "palette.createAndAdd": "Create & Add",
  "palette.add": "Add",
  "palette.working": "Working",
  "palette.lookup": "Lookup",
  "palette.cloning": "Cloning",
  "palette.repository": "Repository",
  "palette.enterGitUrl": "Enter a Git clone URL and press Enter to continue.",
  "palette.enterRepositoryPath": "Enter a repository path and press Enter to look it up.",
  "palette.chooseDestination": "Choose a destination path and press Enter to clone.",
  "palette.relativePathsRequireProject": "Relative paths require an active project.",
  "palette.createFolderAndAdd": "Press Enter to create this folder and add it as a project.",
  "palette.navigate": "Navigate",
  "palette.select": "Select",
  "palette.openIn": "Open in {name}",
  "sidebar.pathCopied": "Path copied",
  "sidebar.copyPathFailed": "Failed to copy path",
  "sidebar.projectTitleRequired": "Project title cannot be empty",
  "sidebar.renameProjectFailed": "Failed to rename project",
  "sidebar.threadTitleRequired": "Thread title cannot be empty",
  "sidebar.renameThreadFailed": "Failed to rename thread",
  "sidebar.settleFailed": "Failed to settle thread",
  "sidebar.unsettleFailed": "Failed to un-settle thread",
  "sidebar.wakeFailed": "Failed to wake thread",
  "sidebar.snoozeFailed": "Failed to snooze thread",
  "sidebar.snoozedUntil": "Snoozed until {time}",
  "sidebar.undo": "Undo",
  "sidebar.deleteThreadsFailed": "Failed to delete threads",
  "sidebar.createThreadFailed": "Could not create thread",
  "sidebar.deleteThreadFailed": "Failed to delete thread",
  "sidebar.deleteThreadsConfirm": {
    one: "Delete {count} thread?",
    other: "Delete {count} threads?",
  },
  "sidebar.removeProjectWithThreadsConfirm": {
    one: 'Remove project "{title}" and delete its {count} thread?',
    other: 'Remove project "{title}" and delete its {count} threads?',
  },
  "sidebar.deleteThreadsProviderImpact":
    "This permanently deletes the Provider conversations owned by those tasks and clears their task history.",
  "sidebar.deleteThreadConfirm":
    'Delete thread "{title}"?\nThis permanently deletes the original Provider conversation and clears this task history.',
  "sidebar.deleteThisThreadConfirm":
    "Delete this thread?\nThis permanently deletes the original Provider conversation and clears this task history.",
  "sidebar.snooze.inOneHour": "In 1 hour",
  "sidebar.snooze.thisEvening": "This evening",
  "sidebar.snooze.tomorrow": "Tomorrow",
  "sidebar.snooze.nextWeek": "Next week",
  "sidebar.snooze.now": "now",
  "settings.title": "Settings",
  "settings.restoreDefaults": "Restore defaults",
  "settings.appearance": "Appearance",
  "settings.theme": "Theme",
  "settings.appearanceDescription": "Choose how So Code looks across the app.",
  "settings.projectGrouping": "Project Grouping",
  "settings.projectGroupingDescription": "Combine matching repositories across environments.",
  "settings.providerUpdates": "Provider update checks",
  "settings.providerUpdatesDescription":
    "Check installed provider CLIs for newer available versions.",
  "settings.newThreads": "New threads",
  "settings.archiveConfirmation": "Archive confirmation",
  "settings.deleteConfirmation": "Delete confirmation",
  "settings.providers": "Providers",
  "settings.general": "General",
  "settings.keybindings": "Keybindings",
  "settings.sourceControl": "Source Control",
  "settings.connections": "Connections",
  "settings.beta": "Beta",
  "settings.archive": "Archive",
  "settings.back": "Back",
  "settings.resetToDefault": "Reset to default",
  "settings.resetLabelToDefault": "Reset {label} to default",
  "settings.restoreDefaultsConfirmTitle": "Restore default settings?",
  "settings.restoreDefaultsConfirmDescription": "This will reset: {labels}.",
  "settings.theme.system": "System",
  "settings.theme.light": "Light",
  "settings.theme.dark": "Dark",
  "settings.glassOpacity": "Glass opacity",
  "settings.glassOpacityDescription":
    "Control how transparent glass surfaces are. Higher values make menus, dialogs, and the composer more solid.",
  "settings.environmentIdentification": "Environment identification",
  "settings.environmentIdentificationDescription":
    "Choose how Dev and Nightly environments are identified.",
  "settings.environmentIdentification.artwork": "Artwork",
  "settings.environmentIdentification.pill": "Version pill",
  "settings.environmentIdentification.none": "None",
  "settings.wordWrap": "Word wrap",
  "settings.wordWrapDescription":
    "Wrap long lines in code blocks, tables, diffs, and file previews by default.",
  "settings.general.timeFormat": "Time format",
  "settings.general.timeFormatDescription":
    "System default follows your browser or OS clock preference.",
  "settings.general.timestampFormat": "Timestamp format",
  "settings.general.timestampFormat.locale": "System default",
  "settings.general.timestampFormat.12Hour": "12-hour",
  "settings.general.timestampFormat.24Hour": "24-hour",
  "settings.general.hideWhitespaceChanges": "Hide whitespace changes",
  "settings.general.hideWhitespaceChangesDescription":
    "Set whether the diff panel ignores whitespace-only edits by default.",
  "settings.general.assistantOutput": "Assistant output",
  "settings.general.assistantOutputDescription":
    "Show token-by-token output while a response is in progress.",
  "settings.general.autoOpenPlanSidebar": "Auto-open Plan sidebar",
  "settings.general.autoOpenPlanSidebarDescription":
    "Open the Plan sidebar when Plan Mode generates a Markdown proposal.",
  "settings.general.newThreadsDescription":
    "Pick the default workspace mode for newly created draft threads.",
  "settings.general.defaultThreadMode": "Default thread mode",
  "settings.general.local": "Local",
  "settings.general.newWorktree": "New worktree",
  "settings.general.startFromOrigin": "Start from origin",
  "settings.general.startFromOriginDescription":
    "Creates the worktree from the latest matching branch on origin instead of your local branch.",
  "settings.general.addProjectStartsIn": "Add project starts in",
  "settings.general.addProjectStartsInDescription":
    'Leave empty to use "~/" when the Add Project browser opens.',
  "settings.general.archiveConfirmationDescription":
    "Require a second click on the inline archive action before a thread is archived.",
  "settings.general.deleteConfirmationDescription":
    "Ask before deleting a thread and its chat history.",
  "settings.general.textGenerationModel": "Text generation model",
  "settings.general.textGenerationModelDescription":
    "Default model for generated text like thread titles and source control content. Source control settings can override it with a dedicated source control writer model.",
  "settings.about": "About",
  "settings.version": "Version",
  "settings.currentVersionDescription": "Current version of the application.",
  "settings.updateAvailable": "Update available.",
  "settings.updateTrackDescription":
    "Stable follows full releases. Nightly follows the nightly desktop channel and can switch back to stable immediately.",
  "settings.hostedUpdateTrackDescription": "Switches the hosted app release channel.",
  "settings.stable": "Stable",
  "settings.nightly": "Nightly",
  "settings.latest": "Latest",
  "settings.diagnostics": "Diagnostics",
  "settings.viewDiagnostics": "View diagnostics",
  "settings.updateTrackChangeFailed": "Could not change update track",
  "settings.updateTrackChangeFailedDescription": "Update track change failed.",
  "settings.downloadFailedDescription": "Download failed.",
  "settings.installFailedDescription": "Install failed.",
  "settings.updateCheckFailedDescription": "Update check failed.",
  "settings.automaticUpdatesUnavailable": "Automatic updates are not available in this build.",
  "settings.restoreLabel.visibleThreads": "Visible threads",
  "settings.restoreLabel.diffWhitespaceChanges": "Diff whitespace changes",
  "settings.restoreLabel.automaticGitFetchInterval": "Automatic Git fetch interval",
  "settings.restoreLabel.newThreadMode": "New thread mode",
  "settings.restoreLabel.newWorktreesStartFromOrigin": "New worktrees start from origin",
  "settings.restoreLabel.addProjectBaseDirectory": "Add project base directory",
  "settings.addProvider": "Add provider instance",
  "settings.keybindings.search": "Search keybindings",
  "settings.keybindings.unknownCondition": "Unknown condition: {identifier}",
  "settings.keybindings.unknownConditions": "Unknown conditions: {identifiers}",
  "settings.keybindings.unknownConditionDescription":
    "So Code does not recognize this condition yet. It can still be saved, but it may not match unless the runtime provides it.",
  "settings.keybindings.conflictsWith": "Conflicts with {labels}.",
  "settings.keybindings.conflictsWithMore": "Conflicts with {labels}, and more.",
  "settings.keybindings.conflictResolution":
    "The most recent matching binding wins when both conditions can apply.",
  "settings.keybindings.condition": "Condition",
  "settings.keybindings.negateCondition": "Negate {condition}",
  "settings.keybindings.negateGroup": "Negate group",
  "settings.keybindings.removeCondition": "Remove condition",
  "settings.keybindings.removeNegatedGroup": "Remove negated group",
  "settings.keybindings.addCondition": "Condition",
  "settings.keybindings.addGroup": "Group",
  "settings.keybindings.removeGroup": "Remove group",
  "settings.keybindings.when": "When",
  "settings.keybindings.always": "Always",
  "settings.keybindings.whenExpression": "When expression",
  "settings.keybindings.fixExpression": "Fix the expression above to continue editing visually.",
  "settings.keybindings.editShortcut": "Edit shortcut for {command}",
  "settings.keybindings.edit": "Edit",
  "settings.keybindings.keybindingFor": "Keybinding for {command}",
  "settings.keybindings.pressShortcut": "Press shortcut",
  "settings.keybindings.unassigned": "Unassigned",
  "settings.keybindings.saving": "Saving",
  "settings.keybindings.save": "Save",
  "settings.keybindings.editWhenClause": "Edit when clause for {command}",
  "settings.keybindings.actionsFor": "Actions for {command}",
  "settings.keybindings.resetToDefault": "Reset to default",
  "settings.keybindings.remove": "Remove",
  "settings.keybindings.newKeybinding": "new keybinding",
  "settings.keybindings.command": "Command",
  "settings.keybindings.keybinding": "Keybinding",
  "settings.keybindings.status": "Status",
  "settings.keybindings.noMatches": "No keybindings match your search.",
  "settings.keybindings.count": {
    one: "{count} binding",
    other: "{count} bindings",
  },
  "settings.keybindings.add": "Add keybinding",
  "settings.keybindings.openFile": "Open keybindings.json",
  "settings.keybindings.webWarning":
    "Some shortcuts may be claimed by the browser before So Code sees them. Use the desktop app for better keybinding support.",
  "settings.keybindings.cancelNew": "Cancel new keybinding",
  "settings.keybindings.cancel": "Cancel",
  "settings.keybindings.openFileFailed": "Unable to open keybindings file",
  "settings.keybindings.openFileFailedDescription": "The keybindings file was not opened.",
  "settings.keybindings.saveFailed": "Unable to save keybinding",
  "settings.keybindings.saveFailedDescription": "The keybinding was not saved.",
  "settings.keybindings.removeFailed": "Unable to remove keybinding",
  "settings.keybindings.removeFailedDescription": "The keybinding was not removed.",
  "settings.keybindings.not": "Not",
  "settings.keybindings.and": "and",
  "settings.keybindings.or": "or",
  "settings.beta.features": "Beta features",
  "settings.beta.sidebarV2": "Sidebar v2",
  "settings.beta.sidebarV2Description":
    "One flat thread list in creation order. Active work renders as rich cards; settled threads collapse to compact rows. Settling requires an up-to-date server — on older servers threads simply stay active. Switch back any time.",
  "settings.beta.enableSidebarV2": "Enable the sidebar v2 beta",
  "settings.beta.autoSettle": "Auto-settle inactive threads",
  "settings.beta.autoSettleDescription":
    "Threads with no activity for this long settle automatically. Threads on merged or closed PRs always settle.",
  "settings.beta.autoSettleAria": "Auto-settle inactive threads",
  "settings.beta.autoSettleDays": "Days of inactivity before auto-settle",
  "settings.beta.autoSettleDaysDescription": "Any new activity un-settles a thread automatically.",
  "settings.archive.unarchive": "Unarchive",
  "settings.archive.delete": "Delete",
  "settings.archive.unarchiveFailed": "Failed to unarchive thread",
  "settings.archive.deleteFailed": "Failed to delete thread",
  "settings.archive.actionFailed": "Archived thread action failed",
  "settings.archive.genericError": "An error occurred.",
  "settings.archive.title": "Archived threads",
  "settings.archive.loading": "Loading archived threads",
  "settings.archive.loadFailed": "Could not load archived threads",
  "settings.archive.empty": "No archived threads",
  "settings.archive.checking": "Checking connected environments.",
  "settings.archive.emptyDescription": "Archived threads will appear here.",
  "settings.archive.actionContext": "Archived {archivedAt} · Created {createdAt}",
  "provider.wizard.driver": "Driver",
  "provider.wizard.identity": "Identity",
  "provider.wizard.config": "Config",
  "provider.wizard.step": "{step}, step {number}",
  "provider.labelPlaceholder": "e.g. Work",
  "provider.optionalPickerMarker": "Optional marker shown in the picker.",
  "provider.noRequiredConfiguration":
    "This driver has no required configuration. You can add the instance now.",
  "provider.addInstance": "Add instance",
  "provider.instanceIdRequired": "Instance ID is required.",
  "provider.instanceExists": 'An instance named "{id}" already exists.',
  "provider.instanceAdded": "Provider instance added",
  "provider.instanceAddFailed": "Could not add provider instance",
  "provider.instanceIdTooLong": "Instance ID must be 64 characters or fewer.",
  "provider.instanceIdInvalid":
    "Instance ID must start with a letter and use only letters, digits, '-', or '_'.",
  "provider.instanceAddedDescription": "{driver} instance '{id}' was added.",
  "provider.environmentVariables": "Environment variables",
  "provider.variable": "Variable",
  "provider.value": "Value",
  "provider.sensitive": "Sensitive",
  "provider.options": "Options",
  "provider.storedSecret": "Stored secret - enter a new value to replace",
  "provider.deleteInstance": "Delete instance",
  "provider.authenticatedAs": "Authenticated as",
  "provider.email": "Email",
  "provider.updating": "Updating",
  "provider.updateNow": "Update now",
  "provider.copyUpdateCommand": "Copy update command",
  "provider.copyCommand": "Copy command",
  "provider.modelsAvailable": "{count} model(s) available",
  "provider.addFavorite": "Add to favorites",
  "provider.removeFavorite": "Remove from favorites",
  "provider.moveUp": "Move up",
  "provider.moveDown": "Move down",
  "provider.showInPicker": "Show in picker",
  "provider.hideFromPicker": "Hide from picker",
  "provider.enterModelSlug": "Enter a model slug.",
  "provider.updateFailed": "Update failed.",
  "provider.useAccent": "Use {color} accent",
  "provider.models": "Models",
  "provider.modelAvailable": "{count} model available",
  "provider.fastMode": "Fast mode",
  "provider.thinking": "Thinking",
  "provider.reasoning": "Reasoning",
  "provider.detailsFor": "Details for {name}",
  "provider.hidden": "hidden",
  "provider.custom": "custom",
  "provider.favoriteAction": "{action} {name} {place} favorites",
  "provider.add": "Add",
  "provider.remove": "Remove",
  "provider.from": "from",
  "provider.to": "to",
  "provider.show": "Show",
  "provider.hide": "Hide",
  "provider.removeCustomModel": "Remove custom model",
  "provider.modelBuiltIn": "That model is already built in.",
  "provider.modelSlugTooLong": "Model slugs must be {count} characters or less.",
  "provider.customModelSaved": "That custom model is already saved.",
  "sourceControl.serverEnvironment": "Server environment",
  "sourceControl.versionControl": "Version Control",
  "sourceControl.providers": "Source Control Providers",
  "sourceControl.authenticated": "Authenticated",
  "sourceControl.notAuthenticated": "Not authenticated",
  "sourceControl.statusUnknown": "Status unknown",
  "sourceControl.fetchInterval": "Fetch interval",
  "sourceControl.seconds": "seconds",
  "sourceControl.scanFailed": "Could not scan the server environment",
  "sourceControl.nothingDetected": "Nothing detected yet",
  "sourceControl.rescan": "Rescan server environment",
  "sourceControl.textGeneration": "Text generation",
  "sourceControl.writingStyle": "Source control writing style",
  "sourceControl.repositoryConventions": "Repository conventions",
  "sourceControl.customInstructions": "Custom instructions",
  "sourceControl.followTemplates": "Follow change request templates",
  "sourceControl.writerModel": "Source control writer model",
  "sourceControl.repositoryConventionsDescription":
    "In each project, matches recent change descriptions and change request titles.",
  "sourceControl.conventionalCommitsDescription":
    "Uses Conventional Commit prefixes for change descriptions; change request titles and descriptions stay concise.",
  "sourceControl.customInstructionsDescription":
    "Applies your instructions to change descriptions and change request titles and descriptions in every project.",
  "sourceControl.customInstructionsPlaceholder":
    "Keep titles concise. Use short bullet points in descriptions.",
  "sourceControl.followTemplatesDescription":
    "Structures change request descriptions using the current repository's template when one is available.",
  "sourceControl.changeRequestTemplates": "change request templates",
  "sourceControl.writerModelDescription":
    "Optional model override for change descriptions, change request titles and descriptions, and branch or bookmark names. Off uses the global text generation model.",
  "sourceControl.useDedicatedWriterModel": "Use a separate source control writer model",
  "sourceControl.toggleAccountVisibility": "Toggle source control account visibility",
  "sourceControl.revealAccount": "Click to reveal account",
  "sourceControl.hideAccount": "Click to hide account",
  "sourceControl.fetchIntervalDescription":
    "Refresh remote branch status in the background. Set this to 0 seconds if Git credentials or security keys should only be prompted by explicit Git actions.",
  "sourceControl.decreaseFetchInterval": "Decrease fetch interval",
  "sourceControl.fetchIntervalInSeconds": "Automatic Git fetch interval in seconds",
  "sourceControl.increaseFetchInterval": "Increase fetch interval",
  "sourceControl.nothingDetectedDescription":
    "Install Git on the server, add optional hosting integrations or credentials your workspace needs, then rescan.",
  "sourceControl.scan": "Scan",
  "sourceControl.rescanDescription": "Rescan Git and hosting integrations",
  "provider.addEnvironmentVariable": "Add",
  "provider.environmentVariablesDescription":
    "Add variables to pass API keys, base URLs, or other per-instance CLI settings.",
  "provider.sensitiveValuesDescription":
    "Sensitive values are stored separately and are not returned to the app after saving.",
  "provider.toggleEmailVisibility": "Toggle account email visibility",
  "provider.revealEmail": "Click to reveal email",
  "provider.hideEmail": "Click to hide email",
  "provider.deleteInstanceAria": "Delete provider instance {id}",
  "provider.updateAvailableDetails": "Update available — view details",
  "provider.updateAvailable": "Update available",
  "provider.toggleDetails": "Toggle {name} details",
  "provider.enable": "Enable {name}",
  "provider.instanceLabel": "Instance label",
  "provider.optionalListLabel": "Optional label shown in the provider list.",
  "provider.accentDescription":
    "Used to distinguish this instance in picker rails and model lists.",
  "provider.updateCommandCopied": "{name} update command copied",
  "provider.runInTerminal": "Run it in a terminal when you are ready to update.",
  "provider.copyUpdateCommandFailed": "Could not copy {name} update command",
  "connections.viewEnvironment": "View environment",
  "connections.viewEnvironmentDescription": "Read threads, status, diffs, and configuration.",
  "connections.operateTasks": "Operate tasks",
  "connections.operateTasksDescription": "Start tasks and perform changes in the environment.",
  "connections.useTerminals": "Use terminals",
  "connections.useTerminalsDescription": "Create terminals and send input to running shells.",
  "connections.writeReviews": "Write reviews",
  "connections.writeReviewsDescription": "Create comments while reviewing changes.",
  "connections.viewAccess": "View access",
  "connections.viewAccessDescription": "Inspect pairing links and authorized clients.",
  "connections.manageAccess": "Manage access",
  "connections.manageAccessDescription": "Issue and revoke credentials for other clients.",
  "connections.viewRelay": "View relay",
  "connections.viewRelayDescription": "Inspect managed relay connectivity.",
  "connections.manageRelay": "Manage relay",
  "connections.manageRelayDescription": "Change managed tunnel connectivity.",
  "connections.grantedScopes": "Granted scopes",
  "connections.scopeCount": "{count} scope(s)",
  "connections.showScopes": "{label}: show {count}",
  "connections.t3Connect": "T3 Connect",
  "connections.enableT3Connect": "Enable T3 Connect",
  "connections.signInT3Connect": "Sign in to T3 Connect to manage this environment.",
  "connections.noManageT3Connect":
    "Your session does not have permission to manage T3 Connect access.",
  "connections.t3ConnectLinked": "T3 Connect linked",
  "connections.tunnelDisabled": "T3 Connect tunnel disabled",
  "connections.t3ConnectUnlinked": "T3 Connect unlinked",
  "connections.t3ConnectAvailable": "This environment is available through T3 Connect.",
  "connections.t3ConnectUnavailable": "This environment is no longer available through T3 Connect.",
  "connections.tunnelRemovedActivityOn":
    "The managed tunnel was removed. Agent activity publishing stays on.",
  "connections.agentActivityEnabled": "Agent activity enabled",
  "connections.agentActivityDisabled": "Agent activity disabled",
  "connections.agentActivityEnabledDescription":
    "This environment publishes agent activity to your mobile clients.",
  "connections.agentActivityDisabledDescription":
    "This environment will stop publishing agent activity.",
  "connections.t3ConnectOnDescription":
    "This environment is available to your other devices through T3 Connect.",
  "connections.t3ConnectOffDescription":
    "Make this environment available to your other devices through T3 Connect.",
  "connections.publishAgentActivity": "Publish agent activity",
  "connections.publishAgentActivityDescription":
    "Send activity from this environment to your mobile clients for push notifications and Live Activities. Works without a T3 Connect tunnel.",
  "connections.publishAgentActivityAria": "Publish agent activity to mobile clients",
  "connections.noRemoteEnvironments": "No saved remote environments",
  "connections.noRemoteEnvironmentsWithCloud":
    "Click “Add environment” to pair another environment, or connect one from T3 Connect.",
  "connections.noRemoteEnvironmentsWithoutCloud":
    "Click “Add environment” to pair another environment.",
  "settings.refreshProviders": "Refresh provider status",
  "provider.addTitle": "Add provider instance",
  "provider.addDescription":
    "Configure an additional provider instance — for example, a second Codex install pointed at a different workspace.",
  "provider.driver": "Driver",
  "provider.label": "Label",
  "provider.instanceId": "Instance ID",
  "provider.accentColor": "Accent color",
  "provider.chooseCustomAccent": "Choose custom accent color for {name}",
  "provider.clearAccent": "Clear accent color for {name}",
  "provider.labelDescription": "Shown in the provider list. Optional.",
  "provider.instanceIdDescription":
    "Routing key used by threads and sessions. Letters, digits, '-', or '_'.",
  "provider.comingSoon": "Coming Soon",
  "provider.clear": "Clear",
  "provider.displayName": "Display name",
  "connections.createPairingLink": "Create pairing link",
  "connections.createPairingDescription":
    "Generate a one-time link that another device can use to pair with this backend as an authorized client.",
  "connections.clientLabel": "Client label (optional)",
  "connections.permissions": "Permissions",
  "connections.tailscaleHttps": "Tailscale HTTPS",
  "connections.networkAccess": "Network access",
  "connections.authorizedClients": "Authorized clients",
  "connections.remoteEnvironments": "Remote environments",
  "connections.addEnvironment": "Add Environment",
  "connections.wslBackend": "WSL backend",
  "connections.wslOnly": "WSL only",
  "updates.track": "Update track",
  "updates.download": "Download",
  "updates.install": "Install",
  "updates.checking": "Checking...",
  "updates.downloading": "Downloading...",
  "updates.upToDate": "Up to Date",
  "updates.check": "Check for Updates",
  "updates.downloadFailed": "Could not download update",
  "updates.installFailed": "Could not install update",
  "updates.checkFailed": "Could not check for updates",
  "pairing.pendingTitle": "Pairing with this environment",
  "pairing.pendingDescription": "Validating the pairing link and preparing your session.",
  "pairing.title": "Pair with this environment",
  "pairing.token": "Pairing token",
  "pairing.tokenPlaceholder": "Paste a one-time token or pairing secret",
  "pairing.inProgress": "Pairing...",
  "pairing.reloadApp": "Reload app",
  "pairing.connectingBackend": "Connecting to this backend.",
  "pairing.missingLink": "This pairing link is missing its backend host or token.",
  "pairing.tokenAlreadySubmitted":
    "This one-time pairing token was already submitted. Request a new pairing link.",
  "pairing.environmentSaved": "{label} is saved in this browser.",
  "pairing.environmentFallback": "The environment",
  "pairing.retryToken":
    "{error} If the backend accepted this one-time token, request a new pairing link before retrying.",
  "pairing.paired": "Backend paired",
  "pairing.failed": "Pairing failed",
  "pairing.backend": "Pairing backend",
  "pairing.host": "Host",
  "pairing.reachabilityHelp":
    "Verify the backend is reachable from this browser, supports CORS for hosted clients, and is served over HTTPS when opening this page from HTTPS.",
  "pairing.openApp": "Open app",
  "pairing.authenticationFailed": "Authentication failed.",
  "pairing.trustedCredential":
    "This environment expects a trusted pairing credential before the app can connect.",
  "pairing.enterToken": "Enter a pairing token to start a session with this environment.",
  "pairing.acceptsDesktopAndToken":
    "Desktop-managed pairing and one-time pairing tokens are both accepted for this environment.",
  "pairing.desktopManaged":
    "This environment is desktop-managed. Open it from the desktop app or paste a bootstrap credential if one was issued explicitly.",
  "pairing.acceptsToken":
    "This environment accepts one-time pairing tokens. Pairing links can open this page directly, or you can paste the token here.",
  "ssh.promptFailed": "SSH password prompt failed.",
  "ssh.promptExpired": "This SSH password prompt expired. Try connecting again.",
  "ssh.expired": "Expired",
  "ssh.dismiss": "Dismiss",
  "ssh.cancel": "Cancel",
  "ssh.passwordRequired": "SSH password required",
  "ssh.passwordDescription":
    "So Code needs your SSH password to connect to {target}. The password is passed to the local SSH process for this connection attempt and is not saved by So Code.",
  "ssh.useKeys": "Use SSH keys to avoid repeated password prompts on new SSH sessions.",
  "ssh.continue": "Continue",
  "connections.showQrCode": "Show QR code",
  "connections.pairingQrTitle": "Pairing link — scan to open on another device",
  "connections.pairingLinkScopes": "Pairing link scopes",
  "connections.copyTokenPair":
    "Copy the token and pair from another client using this backend's reachable host.",
  "connections.copySelectedEndpoint": "Copy selected endpoint",
  "connections.copyPairingUrlFor": "Copy pairing URL for: {label}",
  "connections.chooseEndpoint": "Choose endpoint to copy",
  "connections.copyCode": "Copy code",
  "connections.showLink": "Show link",
  "connections.showCode": "Show code",
  "connections.hostedAppPairingLink": "Hosted app pairing link",
  "connections.pairingLink": "Pairing link",
  "connections.pairingCode": "Pairing code",
  "connections.clipboardHostedUnavailable":
    "Clipboard copy is unavailable here. Open or manually copy this hosted app link on the device you want to connect.",
  "connections.clipboardPairingUrlUnavailable":
    "Clipboard copy is unavailable here. Open or manually copy this full pairing URL on the device you want to connect.",
  "connections.clipboardCodeUnavailable":
    "Clipboard copy is unavailable here. Manually copy this code into another client.",
  "connections.revoking": "Revoking…",
  "connections.revoke": "Revoke",
  "connections.wslLoadFailed": "Couldn't load the WSL backend state.",
  "connections.retrying": "Retrying…",
  "connections.retry": "Retry",
  "connections.wslUnavailable":
    "WSL is no longer available, so the Windows backend is running instead. Switch off the WSL backend to clear this preference.",
  "connections.switchToWindows": "Switch to Windows",
  "connections.off": "Off",
  "connections.defaultDistro": "Default distro",
  "connections.wslDescription":
    "Run a second backend inside a WSL distro alongside the Windows one. Pick a distro to start it; pick Off to stop it. Projects opened against the WSL backend live on the Linux side; Windows projects stay where they are.",
  "connections.wslStartFailed": "WSL backend couldn't start: {error}",
  "connections.defaultSuffix": " (default)",
  "connections.wslOnlyDescription":
    "Stop the Windows backend and run only the WSL backend. Useful if you develop entirely inside WSL and don't want a second backend process. So Code restarts when you change this.",
  "connections.runWslOnly": "Run WSL only",
  "connections.tailscaleAvailableDescription":
    "Use Tailscale Serve to expose this backend through a MagicDNS HTTPS URL.",
  "connections.startTailscaleDescription":
    "Start Tailscale to set up HTTPS access through MagicDNS.",
  "connections.reachableAt": "Reachable at {endpoint}",
  "connections.exposedAllInterfaces": "Exposed on all interfaces.",
  "connections.limitedThisMachine": "Limited to this machine.",
  "connections.loading": "Loading…",
  "connections.remoteAccessConfigured":
    "This backend is already configured for remote access. Network exposure changes must be made where the server is launched.",
  "connections.localOnlyRestart":
    "This backend is only reachable on this machine. Restart it with a non-loopback host to enable remote pairing.",
  "connections.networkChangesControlled":
    "Network exposure changes restart the backend and must be controlled where the server process is launched.",
  "connections.thisEnvironment": "This environment",
  "connections.versionDrift": "Version drift",
  "connections.versionDriftDescription":
    "Client {client}, server {server}. Sync them if RPC calls or reconnects fail.",
  "connections.thisServer": "this server",
  "common.done": "Done",
  "connections.connectedFor": "Connected for {time}",
  "connections.connected": "Connected",
  "connections.lastConnectedAt": "Last connected at {time}",
  "connections.notConnectedYet": "Not connected yet.",
  "connections.thisDevice": "This device",
  "connections.clientScopes": "Client scopes",
  "connections.revokeOthers": "Revoke others",
  "connections.createLink": "Create link",
  "connections.pairingLabelPlaceholder": "e.g. Living room iPad",
  "connections.permissionLimit": "Limit what the paired client can do.",
  "connections.readOnly": "Read only",
  "connections.standard": "Standard",
  "connections.selectPermission": "Select at least one permission.",
  "connections.accessWriteWarning": "This client can create or revoke access for other devices.",
  "connections.creating": "Creating…",
  "connections.createPairingFailed": "Could not create pairing URL",
  "connections.createPairingFailedDescription": "Failed to create pairing URL.",
  "connections.enableNetworkTitle": "Enable network access?",
  "connections.disableNetworkTitle": "Disable network access?",
  "connections.enableNetworkDescription":
    "So Code will restart to expose this environment over the network.",
  "connections.disableNetworkDescription":
    "So Code will restart and limit this environment back to this machine.",
  "connections.restarting": "Restarting…",
  "connections.restartEnable": "Restart and enable",
  "connections.restartDisable": "Restart and disable",
  "connections.turnOffWsl": "Turn off WSL and switch back to Windows?",
  "connections.disableWsl": "Disable WSL backend?",
  "connections.switchWslDistro": "Switch WSL distro?",
  "connections.startWsl": "Start the WSL backend",
  "connections.runOnlyWsl": "Run only the WSL backend?",
  "connections.reenableWindows": "Re-enable the Windows backend?",
  "connections.wslSwitchWindowsDescription":
    "So Code will restart on the Windows backend. Threads and projects opened against WSL stay safe inside the distro and become available again when you re-enable WSL.",
  "connections.wslDisableDescription":
    "The WSL backend will stop. Threads and projects opened against WSL stay safe inside the distro, but they'll be unavailable in So Code until you re-enable WSL.",
  "connections.wslDistroChangeDescription":
    "So Code will restart the WSL backend on the new distro. Sessions still running on the current distro will be interrupted.",
  "connections.wslEnableChoice":
    "Run the WSL backend alongside the Windows one, or stop the Windows backend and use only WSL? You can change this later from Settings.",
  "connections.wslOnlyDescriptionConfirm":
    "So Code will restart and start only the WSL backend. Your Windows-side projects won't be accessible until you turn this off again.",
  "connections.wslReenableWindowsDescription":
    "So Code will restart and bring the Windows backend back up alongside WSL.",
  "connections.applying": "Applying…",
  "connections.useOnlyWsl": "Use only WSL",
  "connections.runBothBackends": "Run both backends",
  "connections.disableWslAction": "Disable WSL",
  "connections.switchDistro": "Switch distro",
  "connections.disableTailscale": "Disable Tailscale HTTPS?",
  "connections.disableTailscaleDescription":
    "So Code will restart the local backend without Tailscale Serve.",
  "connections.setupTailscale": "Set up Tailscale HTTPS?",
  "connections.setupTailscaleDescription":
    "So Code will restart the local backend with Tailscale Serve enabled and ask Tailscale to proxy HTTPS traffic to this backend.",
  "connections.httpsPort": "HTTPS port",
  "connections.invalidHttpsPort": "Enter a port from 1 to 65535.",
  "connections.httpsEndpoint": "HTTPS endpoint",
  "connections.pendingMagicDns": "Pending MagicDNS endpoint",
  "connections.enable": "Enable",
  "connections.administrativeAccess": "Administrative access",
  "connections.administrativeAccessDescription":
    "Pairing links and client-session management require the access:write scope for this backend.",
  "settings.providerCheckedUnavailable": "Checked unavailable",
  "settings.providerChecked": "Checked {time}",
  "sourceControl.comingSoon": "Support for {name} is coming soon.",
  "sourceControl.unavailableOnServer": "Not available on this server: {hint}",
  "sourceControl.authenticatedAs": "Authenticated as",
  "sourceControl.availableWithHint": "Available. {hint}",
  "sourceControl.notAuthenticatedOnServer":
    "{name} is not authenticated on this server. Sign in or configure credentials using the {command} tool on the server host to enable change request features.",
  "sourceControl.verifyFailed": "Could not verify {name}. {hint}",
  "sourceControl.available": "Available",
  "sourceControl.as": "as",
  "connections.searchSshHosts": "Search hosts or type devbox",
  "connections.pairAnotherEnvironment": "Pair another environment to this client.",
  "connections.networkUpdateFailed": "Failed to update network exposure.",
  "connections.networkUpdateFailedTitle": "Could not update network access",
  "connections.tailscaleSetupFailed": "Failed to configure Tailscale HTTPS.",
  "connections.tailscaleSetupFailedTitle": "Could not set up Tailscale HTTPS",
  "connections.tailscaleDisableFailed": "Failed to disable Tailscale HTTPS.",
  "connections.tailscaleDisableFailedTitle": "Could not disable Tailscale HTTPS",
  "connections.revokePairingFailed": "Failed to revoke pairing link.",
  "connections.revokePairingFailedTitle": "Could not revoke pairing link",
  "connections.revokeClientFailed": "Failed to revoke client access.",
  "connections.revokeClientFailedTitle": "Could not revoke client access",
  "connections.revokedOtherClients": "{count} other client(s) revoked",
  "connections.revokedOthersDescription":
    "Other paired clients will need a new pairing link before reconnecting.",
  "connections.revokeOthersFailed": "Failed to revoke other clients.",
  "connections.revokeOthersFailedTitle": "Could not revoke other clients",
  "connections.environmentConnected": "Environment connected",
  "connections.environmentReconnected": "Environment reconnected",
  "connections.sshReady": "{name} is ready over an SSH-managed tunnel.",
  "connections.backendAddFailed": "Failed to add backend.",
  "connections.backendAddFailedTitle": "Could not add backend",
  "connections.backendAdded": "Backend added",
  "connections.backendAddedDescription":
    "The environment is saved and will reconnect on app startup.",
  "connections.backendConnectFailed": "Failed to connect backend.",
  "connections.backendConnectFailedTitle": "Could not connect backend",
  "connections.backendRemoveFailed": "Failed to remove backend.",
  "connections.backendRemoveFailedTitle": "Could not remove backend",
  "connections.host": "Host",
  "connections.sshHostOrAlias": "SSH host or alias",
  "connections.sshHostRequired": "SSH host or alias is required.",
  "connections.sshPortInvalid": "SSH port must be between 1 and 65535.",
  "connections.backendHostRequired": "Enter a backend host.",
  "connections.pairingCodeRequired": "Enter a pairing code.",
  "connections.sshConnectFailed": "Failed to connect SSH host.",
  "connections.pastePairingUrl": "Paste a full pairing URL here to fill both fields automatically.",
  "connections.username": "Username",
  "connections.port": "Port",
  "connections.suggestedHosts": "Suggested hosts",
  "connections.suggestedHostsDescription": "From SSH config and known hosts",
  "connections.noSshHosts": "No new SSH hosts were discovered.",
  "connections.adding": "Adding…",
  "connections.removing": "Removing…",
  "connections.remove": "Remove",
  "connections.connecting": "Connecting…",
  "connections.connect": "Connect",
  "connections.disconnecting": "Disconnecting…",
  "connections.disconnect": "Disconnect",
  "connections.setup": "Setup",
  "connections.disable": "Disable",
  "connections.hide": "Hide",
  "connections.reachableAtLabel": "Reachable at",
  "connections.traceCopied": "Trace ID copied",
  "connections.copyTraceFailed": "Could not copy trace ID",
  "connections.remoteLink": "Remote link",
  "connections.remoteLinkDescription": "Enter a backend host and pairing code.",
  "connections.ssh": "SSH",
  "connections.sshDescription": "Use local SSH config, agent, and tunnels for the backend.",
  "connections.noPairingClients": "No pairing links or client sessions.",
  "connections.wslUpdateFailed": "Failed to update WSL backend.",
  "connections.wslUpdateFailedTitle": "Could not change WSL backend",
  "connections.hostedAppLink": "Hosted app link",
  "connections.backendPairingUrl": "Backend pairing URL",
  "connections.hostedLinkCopied": "Hosted app link copied",
  "connections.pairingUrlCopied": "Pairing URL copied",
  "connections.pairingCodeCopied": "Pairing code copied",
  "connections.openHostedLink": "Open it in the browser on the device you want to connect.",
  "connections.openPairingUrl": "Open it in the client you want to pair to this environment.",
  "connections.pasteCode": "Paste it into another client to finish pairing.",
  "connections.copyHostedFailed": "Could not copy hosted app link",
  "connections.copyPairingUrlFailed": "Could not copy pairing URL",
  "connections.copyPairingCodeFailed": "Could not copy pairing code",
  "connections.clipboardUnavailable": "Clipboard copy unavailable",
  "connections.showFullValue": "Showing the full value instead.",
  "connections.tokenOnly": "Token only",
  "connections.pairingUrls": "Pairing URLs",
  "provider.customHexColor": "Custom hex accent color",
  "provider.environmentVariableName": "Environment variable name {index}",
  "provider.environmentVariableValue": "Environment variable value {index}",
  "provider.markVariableSensitive": "Mark environment variable {name} as sensitive",
  "provider.removeEnvironmentVariable": "Remove environment variable {name}",
  "provider.checkingStatus": "Checking provider status",
  "provider.waitingStatus":
    "Waiting for the server to report installation and authentication details.",
  "provider.disabled": "Disabled",
  "provider.disabledDescription":
    "This provider is installed but disabled for new sessions in So Code.",
  "provider.notFound": "Not found",
  "provider.cliNotFound": "CLI not detected on PATH.",
  "provider.authenticated": "Authenticated",
  "provider.notAuthenticated": "Not authenticated",
  "provider.needsAttention": "Needs attention",
  "provider.couldNotVerify": "The provider is installed, but the server could not fully verify it.",
  "provider.unavailable": "Unavailable",
  "provider.startupCheckFailed": "The provider failed its startup checks.",
  "provider.incompatible": "Incompatible",
  "provider.incompatibleDescription":
    "The provider runtime and its required helper versions or capabilities do not match.",
  "provider.available": "Available",
  "provider.authCouldNotVerify": "Installed and ready, but authentication could not be verified.",
  "provider.updateAvailableInstall": "Update available: install {version}.",
  "provider.updateAvailableLatest": "Update available: install the latest provider version.",
  "diagnostics.noTraceRecords": "No trace records",
  "diagnostics.detailsFor": "{label} details",
  "diagnostics.showFullError": "Show full error",
  "diagnostics.showFullMessage": "Show full message",
  "diagnostics.showLess": "Show less",
  "diagnostics.traceId": "trace ID",
  "diagnostics.copiedTraceId": "Copied trace ID",
  "diagnostics.copyTraceId": "Copy trace ID",
  "diagnostics.copied": "Copied",
  "diagnostics.copyFullTraceId": "Copy full trace ID",
  "diagnostics.subprocess": "Subprocess",
  "diagnostics.agent": "Agent",
  "diagnostics.process": "Process",
  "diagnostics.collapse": "Collapse {name}",
  "diagnostics.expand": "Expand {name}",
  "diagnostics.sendSigint": "Send SIGINT",
  "diagnostics.sendSigkill": "Send SIGKILL",
  "diagnostics.name": "Name",
  "diagnostics.memory": "Memory",
  "diagnostics.command": "Command",
  "diagnostics.type": "Type",
  "diagnostics.kill": "Kill",
  "diagnostics.noLiveDescendantProcesses": "No live descendant processes found.",
  "diagnostics.root": "Root",
  "diagnostics.child": "Child",
  "diagnostics.processAria": "{role} process {name}",
  "diagnostics.cpuChartAria": "Average CPU {average}%, peak CPU {peak}%",
  "diagnostics.cpuChartTooltip": "Avg {average}%, peak {peak}%",
  "diagnostics.cpuTime": "CPU Time",
  "diagnostics.current": "Current",
  "diagnostics.average": "Average",
  "diagnostics.peak": "Peak",
  "diagnostics.maxMemory": "Max Mem",
  "diagnostics.checking": "Checking",
  "diagnostics.checkedUnavailable": "Checked unavailable",
  "diagnostics.checkedWithSuffix": "Checked {value} {suffix}",
  "diagnostics.checked": "Checked {value}",
  "diagnostics.noAvailableEditors": "No available editors found.",
  "diagnostics.noEnvironmentSelected": "No environment is selected.",
  "diagnostics.unableToOpenLogsFolder": "Unable to open logs folder.",
  "diagnostics.confirmSigkill":
    "Send SIGKILL to process {pid}? This cannot be handled by the process.",
  "diagnostics.couldNotSendSignal": "Could not send {signal}",
  "diagnostics.failedToSendSignal": "Failed to send {signal}.",
  "diagnostics.processAlreadyExited": "Process already exited",
  "diagnostics.processNotChild":
    "The process is not a child of the So Code server. It might already have exited.",
  "diagnostics.liveProcesses": "Live Processes",
  "diagnostics.refreshProcessDiagnostics": "Refresh process diagnostics",
  "diagnostics.childProcesses": "Child Processes",
  "diagnostics.childCpuTooltip":
    "Total CPU across live child processes of the current server process. The desktop shell and other parent processes are not included.",
  "diagnostics.childMemoryTooltip":
    "Total resident memory across live child processes of the current server process. The desktop shell and other parent processes are not included.",
  "diagnostics.serverPid": "Server PID",
  "diagnostics.loadingLiveProcesses": "Loading live processes...",
  "diagnostics.resourceHistory": "Resource History",
  "diagnostics.refreshResourceHistory": "Refresh resource history",
  "diagnostics.cpuTimeTooltip":
    "Approximate active CPU time for the So Code server root process and its descendants during the selected window. It grows only while sampled processes use CPU and older samples leave as the window moves.",
  "diagnostics.samples": "Samples",
  "diagnostics.samplesTooltip":
    "In-memory process samples retained by the server. This resets when the server restarts.",
  "diagnostics.interval": "Interval",
  "diagnostics.processes": "Processes",
  "diagnostics.collectingResourceSamples": "Collecting process resource samples...",
  "diagnostics.noResourceSamples": "No process resource samples found for this window.",
  "diagnostics.traceDiagnostics": "Trace Diagnostics",
  "diagnostics.openLogsFolder": "Open logs folder",
  "diagnostics.refreshTraceDiagnostics": "Refresh trace diagnostics",
  "diagnostics.spans": "Spans",
  "diagnostics.failures": "Failures",
  "diagnostics.slowSpans": "Slow Spans",
  "diagnostics.slowSpansTooltip": "Spans with a duration of {duration} or longer.",
  "diagnostics.slowSpansTooltipFallback": "Spans at or above the configured slow-span threshold.",
  "diagnostics.parseErrors": "Parse Errors",
  "diagnostics.partialTraceRead":
    "Some trace files could not be read, so diagnostics may be incomplete. {error}",
  "diagnostics.latestFailures": "Latest Failures",
  "diagnostics.span": "Span",
  "diagnostics.cause": "Cause",
  "diagnostics.duration": "Duration",
  "diagnostics.ended": "Ended",
  "diagnostics.loadingFailures": "Loading failures...",
  "diagnostics.noFailedSpans": "No failed spans found.",
  "diagnostics.mostCommonFailures": "Most Common Failures",
  "diagnostics.count": "Count",
  "diagnostics.lastSeen": "Last Seen",
  "diagnostics.loadingFailureGroups": "Loading failure groups...",
  "diagnostics.noRepeatedFailures": "No repeated failures found.",
  "diagnostics.slowestSpans": "Slowest Spans",
  "diagnostics.trace": "Trace",
  "diagnostics.loadingSlowSpans": "Loading slow spans...",
  "diagnostics.noSpans": "No spans found.",
  "diagnostics.spanLogs": "Span Logs",
  "diagnostics.time": "Time",
  "diagnostics.level": "Level",
  "diagnostics.message": "Message",
  "diagnostics.loadingRecentLogs": "Loading recent logs...",
  "diagnostics.noWarningsOrErrors": "No warnings or errors found.",
  "diagnostics.topSpanNames": "Top Span Names",
  "diagnostics.max": "Max",
  "diagnostics.loadingSpanNames": "Loading span names...",
  "webMisc.expandedImagePreview": "Expanded image preview",
  "webMisc.closeImagePreview": "Close image preview",
  "webMisc.previousImage": "Previous image",
  "webMisc.nextImage": "Next image",
  "webMisc.unableToUpdatePreview": "Unable to update popped-out preview",
  "webMisc.anErrorOccurred": "An error occurred.",
  "webMisc.floatingBrowserPreview": "Floating browser preview",
  "webMisc.openPreviewInRightPanel": "Open preview in right panel",
  "webMisc.closePoppedOutPreview": "Close popped-out preview",
  "webMisc.popPreviewOut": "Pop preview into separate window",
  "webMisc.closeSeparateWindow": "Close separate window",
  "webMisc.popIntoSeparateWindow": "Pop into separate window",
  "webMisc.closeFloatingPreview": "Close floating preview",
  "webMisc.resizeFloatingPreview": "Resize floating preview",
  "webMisc.on": "On",
  "webMisc.off": "Off",
  "webMisc.pushNotifications": "Push notifications",
  "webMisc.liveActivities": "Live Activities",
  "webMisc.loadingMobileClients": "Loading mobile clients",
  "webMisc.noMobileClients": "No mobile clients",
  "webMisc.noMobileClientsDetail":
    "Sign in to So Code on your iPhone to register it for push notifications and Live Activities.",
  "webMisc.mobileClients": "Mobile clients",
  "webMisc.mobileClientsDetail":
    "Devices registered to receive T3 Connect activity from your environments.",
  "webMisc.refresh": "Refresh",
  "webMisc.couldNotLoadMobileClients": "Could not load mobile clients",
  "webMisc.signInToT3Connect": "Sign in to T3 Connect",
  "webMisc.scriptNameRequired": "Name is required.",
  "webMisc.scriptCommandRequired": "Command is required.",
  "webMisc.failedToSaveAction": "Failed to save action.",
  "webMisc.failedToImportAction": "Failed to import action.",
  "webMisc.localBackendUnavailable": "Local backend API is unavailable before a backend is paired.",
  "webMisc.unableToOpenLink": "Unable to open link.",
  "webMisc.localApiNotFound": "Local API not found",
  "fileBrowser.copyMention": "Copy mention",
  "fileBrowser.addToChat": "Add to chat",
  "fileBrowser.mentionCopied": "Mention copied",
  "fileBrowser.copyMentionFailed": "Failed to copy mention",
  "fileBrowser.addToChatFailed": "Unable to add to chat",
  "fileBrowser.openChatFirst": "Open a chat for this project and try again.",
  "fileBrowser.chatNotReady": "The chat isn't ready to accept input right now.",
  "fileBrowser.indexing": "Indexing…",
  "fileBrowser.search": "Search workspace files",
  "fileBrowser.refresh": "Refresh workspace files",
  "diff.workingTree": "Working tree",
  "diff.branchChanges": "Branch changes",
  "diff.latestTurn": "Latest turn",
  "diff.turn": "Turn {count}",
  "diff.turnLabel": "Turn",
  "diff.scope": "Diff scope: {scope}",
  "diff.comparing": "Comparing {head} against {base}",
  "diff.changeTarget": "Change comparison target. Currently {target}",
  "diff.searchRefs": "Search refs…",
  "diff.branch": "Branch",
  "diff.remote": "Remote",
  "diff.noMatchingRefs": "No matching refs.",
  "diff.automatic": "Automatic",
  "diff.useRemote": "Use remote version of {name}",
  "diff.remoteOnly": "Remote only",
  "diff.expandAllFiles": "Expand all files",
  "diff.collapseAllFiles": "Collapse all files",
  "diff.stackedView": "Stacked diff view",
  "diff.splitView": "Split diff view",
  "diff.disableLineWrapping": "Disable line wrapping",
  "diff.enableLineWrapping": "Enable line wrapping",
  "diff.showWhitespaceChanges": "Show whitespace changes",
  "diff.hideWhitespaceChanges": "Hide whitespace changes",
  "diff.selectThread": "Select a thread to inspect turn diffs.",
  "diff.notGitRepository":
    "Turn diffs are unavailable because this project is not a git repository.",
  "diff.noCompletedTurns": "No completed turns yet.",
  "diff.truncated":
    "This diff was truncated because it exceeded the preview limit. The changes shown are incomplete.",
  "diff.loadingCheckpoint": "Loading checkpoint diff…",
  "diff.loadingWorkingTree": "Loading working tree diff…",
  "diff.loadingBranch": "Loading branch diff…",
  "diff.noNetChanges": "No net changes in this selection.",
  "diff.noPatch": "No patch available for this selection.",
  "diff.expandFile": "Expand {path}",
  "diff.collapseFile": "Collapse {path}",
  "diff.expandDiff": "Expand diff",
  "diff.collapseDiff": "Collapse diff",
  "scripts.fromT3Json": "From t3.json",
  "scripts.import": "Import",
  "scripts.groupLabel": "Project scripts",
  "scripts.run": "Run {name}",
  "scripts.actions": "Script actions",
  "scripts.setupSuffix": "{name} (setup)",
  "scripts.edit": "Edit {name}",
  "scripts.addAction": "Add action",
  "scripts.projectActions": "Project actions",
  "scripts.editAction": "Edit Action",
  "scripts.addActionTitle": "Add Action",
  "scripts.description":
    "Actions are project-scoped commands you can run from the top bar or keybindings.",
  "scripts.name": "Name",
  "scripts.chooseIcon": "Choose icon",
  "scripts.namePlaceholder": "Test",
  "scripts.keybinding": "Keybinding",
  "scripts.keybindingPlaceholder": "Press shortcut",
  "scripts.keybindingHelp": "Press a shortcut. Use Backspace to clear.",
  "scripts.command": "Command",
  "scripts.previewUrl": "Preview URL (optional)",
  "scripts.previewHelp": "Open this URL in the in-app preview when this action runs.",
  "scripts.runOnWorktreeCreate": "Run automatically on worktree creation",
  "scripts.autoOpenPreview": "Open preview automatically when this action runs",
  "scripts.saveChanges": "Save changes",
  "scripts.saveAction": "Save action",
  "scripts.deleteTitle": 'Delete action "{name}"?',
  "scripts.deleteDescription": "This action cannot be undone.",
  "scripts.deleteAction": "Delete action",
  "scripts.icon.play": "Play",
  "scripts.icon.test": "Test",
  "scripts.icon.lint": "Lint",
  "scripts.icon.configure": "Configure",
  "scripts.icon.build": "Build",
  "scripts.icon.debug": "Debug",
} as const;

const zhCNMessages = {
  "thread.localImageUnavailable": "图片保存在电脑，当前无法在此预览。",
  "common.close": "关闭",
  "common.back": "返回",
  "common.cancel": "取消",
  "common.continue": "继续",
  "common.delete": "删除",
  "common.next": "下一步",
  "common.search": "搜索",
  "common.submit": "提交",
  "common.tryAgain": "重试",
  "markdown.mermaid.rendering": "正在生成图表",
  "markdown.mermaid.renderError": "无法生成 Mermaid 图表，已显示源代码。",
  "markdown.mermaid.expand": "放大查看图表",
  "markdown.mermaid.viewerTitle": "Mermaid 图表",
  "markdown.mermaid.zoomOut": "缩小",
  "markdown.mermaid.zoomIn": "放大",
  "markdown.mermaid.fit": "适应窗口",
  "sidebar.status.working": "进行中",
  "sidebar.status.approval": "待审批",
  "sidebar.status.input": "待输入",
  "sidebar.status.failed": "失败",
  "sidebar.status.woke": "已唤醒",
  "sidebar.status.done": "已完成",
  "sidebar.status.deleting": "正在删除",
  "sidebar.search": "搜索任务和命令",
  "sidebar.newThread": "新建任务",
  "sidebar.newThreadWithShortcut": "新建任务（{shortcut}）",
  "sidebar.newThreadInProject": "在 {project} 中新建任务",
  "sidebar.goToThreads": "返回任务列表",
  "sidebar.newProject": "新建项目",
  "sidebar.allProjects": "所有项目",
  "sidebar.snoozed": "稍后处理",
  "sidebar.snoozedCount": "稍后处理（{count}）",
  "sidebar.settled": "已处理",
  "sidebar.settledCount": "已处理（{count}）",
  "sidebar.showMore": "再显示 {count} 项",
  "sidebar.noProjects": "暂无项目",
  "sidebar.noThreads": "暂无任务",
  "sidebar.noThreadsInProject": "{project} 中暂无任务",
  "sidebar.newThreadOnBranch": "在 {branch} 上新建任务",
  "sidebar.settle": "完成",
  "sidebar.unsettle": "恢复",
  "sidebar.settleThread": "标记为已处理",
  "sidebar.unsettleThread": "标记为待处理",
  "sidebar.snoozeThread": "稍后处理",
  "sidebar.wakeThread": "唤醒任务",
  "sidebar.renameThread": "重命名任务",
  "sidebar.markUnread": "标记为未读",
  "sidebar.copyPath": "复制路径",
  "sidebar.copyThreadId": "复制任务 ID",
  "sidebar.actionCount.settle": "标记为已处理（{count}）",
  "sidebar.actionCount.snooze": "稍后处理（{count}）",
  "sidebar.actionCount.markUnread": "标记为未读（{count}）",
  "sidebar.actionCount.delete": "删除（{count}）",
  "sidebar.addProject": "添加项目",
  "sidebar.projectSettings": "项目设置",
  "sidebar.renameProject": "重命名",
  "sidebar.groupProject": "项目分组…",
  "sidebar.removeProject": "移除",
  "sidebar.copyProjectPath": "复制项目路径",
  "sidebar.projectName": "项目名称",
  "sidebar.groupingRule": "分组规则",
  "sidebar.currentEnvironment": "当前环境",
  "providerImport.title": "导入 Provider 对话",
  "providerImport.description": "为 {project} 选择一个已有对话。",
  "providerImport.projectUnavailable": "请先选择项目，再导入对话。",
  "providerImport.providers": "Provider",
  "providerImport.search": "搜索对话…",
  "providerImport.sort.recent": "最近",
  "providerImport.sort.oldest": "最早",
  "providerImport.timeFilter": "按最后活动时间筛选",
  "providerImport.time.all": "不限时间",
  "providerImport.time.7d": "7 天内",
  "providerImport.time.30d": "30 天内",
  "providerImport.time.90d": "90 天内",
  "providerImport.refresh": "刷新对话",
  "providerImport.loading": "正在加载对话…",
  "providerImport.loadMore": "加载更多",
  "providerImport.loadingMore": "正在加载更多…",
  "providerImport.empty": "此项目没有可导入的对话。",
  "providerImport.noMatches": "没有匹配的对话。",
  "providerImport.noProviders": "已配置的 Provider 均不支持对话导入。",
  "providerImport.unavailable.unsupported": "此 Provider 不支持对话导入。",
  "providerImport.unavailable.configurationConflict":
    "多个已启用的 Provider 实例使用同一个会话存储，因此无法导入对话。",
  "providerImport.status.available": "可导入",
  "providerImport.status.busy": "使用中",
  "providerImport.status.activityUnknown": "状态未知",
  "providerImport.status.alreadyImported": "已导入",
  "providerImport.status.archived": "已归档",
  "providerImport.status.deleting": "正在删除",
  "providerImport.confirmStopped":
    "So Code 无法确认外部活动状态。我确认使用此对话的其他 Provider 客户端均已停止。",
  "providerImport.directBindWarning":
    "Direct bind 会将原 Provider 对话的所有权转移给此任务。请勿在其他客户端并发使用；删除此任务也会永久删除原对话。",
  "providerImport.noModel": "此 Provider 没有可用于导入任务的模型。",
  "providerImport.failed": "无法导入 Provider 对话。",
  "providerImport.error.project-not-found": "此项目已不可用。",
  "providerImport.error.provider-unavailable": "此 Provider 当前不可用。",
  "providerImport.error.import-unsupported": "此 Provider 不支持对话导入。",
  "providerImport.error.configuration-conflict": "Provider 配置冲突，当前无法导入对话。",
  "providerImport.error.candidate-invalid": "所选对话无效，请刷新列表后重试。",
  "providerImport.error.candidate-stale": "所选对话已过期，请刷新列表后重试。",
  "providerImport.error.session-unavailable": "此 Provider 对话已不可用。",
  "providerImport.error.session-busy": "此 Provider 对话正在其他客户端中使用。",
  "providerImport.error.confirmation-required": "请确认使用此对话的其他 Provider 客户端均已停止。",
  "providerImport.error.deleting-conflict": "已导入的任务正在删除。",
  "providerImport.error.history-unavailable": "无法读取 Provider 对话历史。",
  "providerImport.error.persistence-failed": "无法保存导入的对话。",
  "providerImport.import": "导入对话",
  "providerImport.importing": "正在导入…",
  "composer.submitting": "提交中…",
  "composer.submit": "提交",
  "composer.next": "下一步",
  "composer.nextQuestion": "下一题",
  "composer.submitAnswers": "提交答案",
  "composer.previousQuestion": "上一题",
  "composer.previous": "上一步",
  "composer.stopGeneration": "停止生成",
  "composer.sending": "发送中…",
  "composer.refine": "优化",
  "composer.implement": "开始实现",
  "composer.implementationActions": "实现操作",
  "composer.implementNewThread": "在新任务中实现",
  "composer.environmentDisconnected": "环境已断开连接",
  "composer.connecting": "正在连接",
  "composer.preparingWorktree": "正在准备工作树",
  "composer.sendMessage": "发送消息",
  "composer.queueMessage": "加入队列",
  "composer.queueLabel": "排队消息",
  "composer.queueCount": "{count} 条排队消息",
  "composer.queueAttachmentOnly": "图片附件",
  "composer.queueDispatching": "发送中…",
  "composer.queueSteering": "正在引导…",
  "composer.queueEdit": "编辑排队消息",
  "composer.queueDelete": "删除排队消息",
  "composer.queueSteer": "将排队消息改为引导",
  "composer.queueSaveEdit": "保存排队消息",
  "composer.queueCancelEdit": "取消编辑排队消息",
  "composer.queueEditFailed": "无法更新排队消息",
  "composer.queueDeleteFailed": "无法删除排队消息",
  "composer.queueSteerFailed": "无法使用排队消息引导当前轮次",
  "composer.runtimeMode": "运行模式",
  "composer.runtime.supervised": "监督模式",
  "composer.runtime.supervisedDescription": "执行命令和修改文件前询问",
  "composer.runtime.autoAccept": "自动接受编辑",
  "composer.runtime.autoAcceptDescription": "自动批准编辑，其他操作仍需询问",
  "composer.runtime.auto": "自动",
  "composer.runtime.autoDescription": "由 AI 审核常规操作，高风险操作仍需询问",
  "composer.runtime.fullAccess": "完全访问",
  "composer.runtime.fullAccessDescription": "允许执行命令和编辑，无需逐次确认",
  "composer.runtimeLockedAfterStart": "任务开始后无法更改 Agent Runtime",
  "composer.runProviderCommand": "运行 Provider 命令",
  "composer.scopedSkill": "{scope} 技能",
  "composer.runProviderSkill": "运行 Provider 技能",
  "composer.skills": "技能",
  "composer.builtIn": "内置",
  "composer.provider": "Provider",
  "composer.searchingSkills": "正在搜索工作区技能…",
  "composer.noSkills": "未找到技能。输入 / 浏览 Provider 命令",
  "composer.searchingFiles": "正在搜索工作区文件…",
  "composer.noMatchingFiles": "没有匹配的文件或文件夹",
  "composer.noMatchingCommand": "没有匹配的命令",
  "contextWindow.title": "上下文窗口",
  "contextWindow.tokensUsed": "已使用 {tokens}",
  "contextWindow.totalProcessed": "累计处理",
  "contextWindow.autoCompacts": "{provider} 会在需要时自动压缩上下文。",
  "contextWindow.autoCompactsFallback": "系统会在需要时自动压缩上下文。",
  "contextWindow.status.healthy": "正常",
  "contextWindow.status.warning": "使用率较高",
  "contextWindow.status.critical": "接近上限",
  "contextWindow.aria.percentageUsed": "上下文窗口：已使用 {percentage}，{status}",
  "contextWindow.aria.tokensUsed": "上下文窗口：已使用 {tokens}",
  "composer.planModeTooltip": "规划模式，点击返回常规构建模式",
  "composer.buildModeTooltip": "常规模式，点击进入规划模式",
  "composer.hideSidebar": "隐藏{label}侧边栏",
  "composer.showSidebar": "显示{label}侧边栏",
  "composer.plan": "规划",
  "composer.build": "构建",
  "tasks.progress": "第 {current} / {total} 步",
  "tasks.expand": "展开任务列表",
  "tasks.collapse": "收起任务列表",
  "tasks.status.pending": "待处理",
  "tasks.status.inProgress": "进行中",
  "tasks.status.completed": "已完成",
  "tasks.accessibility.summary": "任务进度，{progress}",
  "tasks.accessibility.step": "{step}，{status}",
  "activityGroup.count": "{count} 项活动",
  "activityGroup.toolCalls": "{count} 次工具调用",
  "activityGroup.expand": "显示活动详情：{summary}",
  "activityGroup.collapse": "隐藏活动详情：{summary}",
  "activityGroup.workLog": "工作日志",
  "activityGroup.reasoning": "思考过程",
  "activityGroup.reasoningInProgress": "正在思考…",
  "activityGroup.toolDetailTruncated": "工具详情已截断至预览上限。",
  "activityGroup.current.command": "运行命令",
  "activityGroup.current.fileRead": "读取文件",
  "activityGroup.current.fileSearch": "搜索文件",
  "activityGroup.current.fileChange": "编辑文件",
  "activityGroup.current.webSearch": "搜索网页",
  "activityGroup.summary.mcpTools": "使用 {count} 个 MCP 工具",
  "activityGroup.summary.readFiles": "读取 {count} 个文件",
  "activityGroup.summary.fileSearches": "执行 {count} 次文件搜索",
  "activityGroup.summary.changedFiles": "修改 {count} 个文件",
  "activityGroup.summary.commands": "运行 {count} 条命令",
  "activityGroup.summary.webSearches": "执行 {count} 次网页搜索",
  "activityGroup.summary.otherTools": "使用 {count} 个其他工具",
  "activityGroup.summary.separator": "、",
  "plan.sidebar.title": "计划",
  "plan.sidebar.actions": "计划操作",
  "plan.sidebar.copied": "已复制",
  "plan.sidebar.copyMarkdown": "复制规划模式 Markdown",
  "plan.sidebar.downloadMarkdown": "下载规划模式 Markdown",
  "plan.sidebar.saveMarkdown": "将规划模式 Markdown 保存到工作区",
  "plan.sidebar.proposal": "规划模式提案",
  "plan.sidebar.emptyTitle": "暂无提议的计划",
  "plan.sidebar.emptyDescription": "规划模式生成的 Markdown 将显示在这里",
  "plan.sidebar.saved": "计划已保存",
  "plan.sidebar.saveFailed": "无法保存计划",
  "composer.switchResponseModel": "切换此任务的回复模型",
  "composer.switchToPlanMode": "将此任务切换到规划模式",
  "composer.switchToBuildMode": "将此任务切回常规构建模式",
  "composer.writeCustomAnswer": "填写自定义答案",
  "composer.expand": "展开输入框",
  "composer.customAnswerPlaceholder": "填写自定义答案，或留空使用已选选项",
  "composer.enableProvider": "在设置中启用 Provider",
  "composer.askAnythingShort": "输入任何内容…",
  "composer.resolveApproval": "请先处理此审批请求再继续",
  "composer.planFeedbackPlaceholder": "添加反馈以优化计划，或留空直接开始实现",
  "composer.chooseProjectPlaceholder": "请先在上方选择项目以开始任务",
  "composer.enableProviderToSend": "请先在设置中启用 Provider 再发送消息",
  "composer.disconnectedPlaceholder": "输入后续修改要求或添加图片",
  "composer.defaultPlaceholder": "输入内容，使用 @ 引用文件、$ 使用技能或 / 执行命令",
  "composer.stashRestoreMayReappear": "恢复的提示可能会重新出现在暂存区",
  "composer.stashRestoreMayReappearDescription": "浏览器存储未能更新，重新加载后此条目可能仍然存在",
  "composer.stashImagesTooLarge": "保存提示时，{names} 超出了暂存大小限制",
  "composer.stashImagesUnreadable": "保存提示时无法读取 {names}",
  "composer.stashImagesOverLimit": "输入框最多可添加 {count} 张图片，无法恢复 {names}",
  "composer.someImagesNotRestored": "部分图片未能恢复",
  "composer.stashEntryMayReturn": "暂存条目可能会再次出现",
  "composer.stashEntryMayReturnDescription": "浏览器存储未能删除，重新加载后此提示可能再次出现",
  "composer.stashFailed": "无法暂存此提示",
  "composer.stashFailedDescription": "浏览器存储写入失败，输入内容保持不变，请释放站点数据后重试",
  "composer.stashSessionOnly": "暂存提示无法在重新加载后保留",
  "composer.stashSessionOnlyDescription": "浏览器存储不可用，此暂存仅在当前会话的内存中保留",
  "composer.oldestStashDiscarded": "已丢弃最早的暂存提示",
  "composer.oldestStashDiscardedDescription": "暂存区最多保留 {count} 条提示，已移除最早的一条",
  "composer.stashImagesNotSaved": "暂存图片未能保存",
  "composer.stashImagesNotSavedDescription":
    "提示已暂存，但浏览器存储拒绝保存图片，重新加载后图片将会丢失",
  "composer.stashImagesNotAttached": "暂存图片未能添加",
  "composer.stashImagesNotAttachedDescription":
    "图片保存完成前提示已被恢复或删除，如仍需要这 {count} 张图片，请重新添加",
  "composer.answerPlanBeforeImages": "请先回答规划问题再添加图片",
  "composer.unsupportedAttachment": "不支持文件“{name}”的类型，请仅添加图片文件",
  "composer.attachmentTooLarge": "文件“{name}”超出 {limit} 的附件大小限制",
  "composer.attachmentCountLimit": "每条消息最多可添加 {count} 张图片",
  "composer.addToChatFailed": "无法添加到聊天",
  "composer.busyTryAgain": "输入框正忙，请稍后重试",
  "composer.previewImage": "预览 {name}",
  "composer.attachmentMayNotPersist": "草稿附件可能无法保留",
  "composer.attachmentMayNotPersistDescription": "草稿附件无法保存到本地，导航后可能丢失",
  "composer.removeImage": "移除 {name}",
  "draft.changeProject": "切换项目",
  "draft.chooseProject": "选择项目",
  "draft.newProject": "新建项目",
  "draft.addProject": "添加项目",
  "draft.whatBuildPrefix": "要在",
  "draft.whatBuildSuffix": "中构建什么？",
  "draft.chooseProjectToStartSuffix": "以开始",
  "draft.addProjectToStart": "添加项目以开始",
  "approval.pending": "待审批",
  "approval.commandRequested": "请求执行命令授权",
  "approval.fileReadRequested": "请求读取文件授权",
  "approval.fileChangeRequested": "请求修改文件授权",
  "approval.command": "命令",
  "approval.fileToRead": "要读取的文件",
  "approval.fileChange": "文件修改",
  "chat.reconnectFailed": "无法重新连接环境",
  "chat.reconnectFailedFallback": "重新连接失败",
  "chat.versionMismatch": "客户端与服务器版本不一致",
  "chat.versionMismatchDescription": "客户端 {client} 已连接到 {serverLabel} {server}",
  "chat.deletedAction": "已删除操作“{name}”",
  "chat.unknown": "未知",
  "chat.deleteActionFailed": "无法删除操作",
  "chat.unexpectedError": "发生意外错误",
  "chat.copyPathFailed": "无法复制路径",
  "chat.clipboardUnavailable": "剪贴板 API 不可用",
  "chat.pathCopied": "已复制路径",
  "chat.unsettleFailed": "无法标记任务为待处理",
  "chat.wakeFailed": "无法唤醒任务",
  "chat.switchCheckoutFailed": "无法切换检出状态",
  "chat.checkoutThreadUpdateFailed": "检出状态已切换，但无法更新任务",
  "chat.chooseProject": "请先选择项目",
  "chat.projectUnavailable": "此草稿不再指向可用项目",
  "chat.implementationThreadStartFailed": "无法启动实现任务",
  "timeline.status.connecting": "正在连接",
  "timeline.native.subtaskRequest": "交给 {agent} 的子任务：{description}",
  "timeline.native.agentReference": "代理引用：{agent}",
  "timeline.native.retryAttempt": "正在重试提供方请求（第 {attempt} 次）",
  "timeline.native.retryNext": "下次尝试时间：{time}",
  "timeline.native.contextCompacted": "上下文已压缩",
  "timeline.native.contextCompactedAutomatic": "上下文已自动压缩",
  "timeline.native.contextCompactedOverflow": "达到上限后已压缩上下文",
  "timeline.native.filesChanged": "已修改 {count} 个文件",
  "chat.scrollToEnd": "滚动到底部",
  "chat.branchChangedWas": "分支已更改，原为",
  "chat.errorOccurred": "发生错误",
  "chat.reconnectBeforeSending": "请先重新连接此环境，再发送消息或运行操作",
  "chat.reconnecting": "正在重新连接…",
  "chat.reconnect": "重新连接",
  "chat.connections": "连接",
  "liveSubagents.liveSubagents": "实时子代理",
  "liveSubagents.rosterLabel": "实时子代理列表",
  "liveSubagents.agentCountOne": "{count} 个代理",
  "liveSubagents.agentCountOther": "{count} 个代理",
  "liveSubagents.openAgent": "在代理面板中打开 {name}，状态：{status}",
  "liveSubagents.agentFallback": "代理",
  "liveSubagents.dock.agents": "代理 {count}",
  "liveSubagents.dock.running": "{count} 个运行中",
  "liveSubagents.dock.attention": "{count} 个需要处理",
  "liveSubagents.dock.attentionSuffix": "，{attention}",
  "liveSubagents.dock.open": "打开代理面板：{agents}，{running}{attention}",
  "liveSubagents.connecting": "正在连接实时代理…",
  "liveSubagents.loadingActivity": "正在加载实时活动…",
  "liveSubagents.truncationNotice": "较早的实时活动已被移除，以保持此视图流畅",
  "liveSubagents.empty": "没有实时子代理",
  "liveSubagents.runtimeEnded": "运行时已结束",
  "liveSubagents.runtimeEndedDescription": "提供方运行时停止后，此实时视图已过期",
  "liveSubagents.agentsUnavailable": "代理不可用",
  "liveSubagents.transportError": "无法加载实时代理",
  "liveSubagents.status.pending": "等待中",
  "liveSubagents.status.running": "运行中",
  "liveSubagents.status.waiting": "等待中",
  "liveSubagents.status.completed": "已完成",
  "liveSubagents.status.failed": "失败",
  "liveSubagents.status.stopped": "已停止",
  "liveSubagents.model": "模型：{model}",
  "liveSubagents.reasoningEffort": "推理强度：{effort}",
  "liveSubagents.reasoningEffort.minimal": "最小",
  "liveSubagents.reasoningEffort.low": "低",
  "liveSubagents.reasoningEffort.medium": "中",
  "liveSubagents.reasoningEffort.high": "高",
  "liveSubagents.reasoningEffort.xhigh": "超高",
  "liveSubagents.reasoningEffort.max": "最大",
  "liveSubagents.emptyActivity": "暂无活动",
  "liveSubagents.activityUnavailable": "此提供方提供实时代理状态，但暂不提供活动详情",
  "liveSubagents.lifecycleOnly": "此提供方仅提供生命周期活动",
  "liveSubagents.lifecycle.started": "代理已启动",
  "liveSubagents.lifecycle.running": "代理运行中",
  "liveSubagents.lifecycle.waiting": "代理等待中",
  "liveSubagents.lifecycle.resumed": "代理已恢复",
  "liveSubagents.lifecycle.completed": "代理已完成",
  "liveSubagents.lifecycle.failed": "代理失败",
  "liveSubagents.lifecycle.stopped": "代理已停止",
  "liveSubagents.reasoning": "推理",
  "liveSubagents.tool.call": "工具调用",
  "liveSubagents.tool.input": "输入",
  "liveSubagents.tool.output": "输出",
  "liveSubagents.tool.error": "错误",
  "liveSubagents.unavailable.unsupported": "此提供方运行时不提供实时子代理",
  "liveSubagents.unavailable.runtimeNotLive": "提供方运行时已不再运行",
  "liveSubagents.unavailable.timedOut": "提供方未能及时响应观察请求",
  "liveSubagents.unavailable.transport": "与提供方的实时活动连接已中断",
  "liveSubagents.unavailable.malformed": "提供方返回了当前客户端无法读取的观察数据",
  "liveSubagents.unavailable.rejected": "提供方拒绝了实时观察请求",
  "liveSubagents.unavailable.default": "实时子代理观察当前不可用",
  "threadSummary.summary": "摘要",
  "threadSummary.open": "打开任务摘要",
  "threadSummary.environment": "环境信息",
  "threadSummary.sourceControl": "源代码管理",
  "threadSummary.machine": "运行位置",
  "threadSummary.workspace": "工作区",
  "threadSummary.path": "路径",
  "threadSummary.branch": "分支",
  "threadSummary.changes": "更改",
  "threadSummary.locked": "已锁定",
  "threadSummary.workspaceLockedDescription": "任务开始后无法切换工作区。",
  "threadSummary.loadingStatus": "正在加载状态…",
  "threadSummary.statusUnavailable": "状态不可用",
  "threadSummary.notRepository": "不是 Git 仓库",
  "threadSummary.noChanges": "没有更改",
  "threadSummary.diffAvailableAfterStart": "任务开始后可查看差异。",
  "threadSummary.detachedHead": "当前处于分离 HEAD 状态，没有检出分支。",
  "threadSummary.branchMismatch": "任务需要 {threadBranch}；当前检出的是 {currentBranch}。",
  "threadSummary.changesCount": "新增 {additions} 行，删除 {deletions} 行",
  "threadSummary.openChanges": "在差异中打开更改：新增 {additions} 行，删除 {deletions} 行",
  "chat.runScriptFailed": "无法运行脚本“{name}”",
  "chat.scriptNotFound": "未找到脚本",
  "chat.threadSnoozed": "此任务已稍后处理",
  "chat.threadSettled": "此任务已处理",
  "chat.snoozedDescription": "发送消息会将其唤醒并移回侧边栏的进行中列表",
  "chat.settledDescription": "发送消息会将其移回侧边栏的进行中列表",
  "chat.waking": "正在唤醒…",
  "chat.wakeNow": "立即唤醒",
  "chat.unsettling": "正在标记为待处理…",
  "chat.unsettle": "标记为待处理",
  "chat.restoring": "正在恢复…",
  "chat.restoreBranch": "恢复分支",
  "chat.dismissBranchNotice": "关闭分支变更提示",
  "chat.reconnectBeforeRevert": "请先重新连接 {environment}，再回退检查点",
  "chat.interruptBeforeRevert": "请先中断当前轮次，再回退检查点",
  "chat.revertConfirm": "要将工作区恢复到检查点 {count} 吗？\nProvider 对话历史不会改变",
  "chat.revertToCheckpoint": "恢复工作区检查点",
  "chat.noActiveProjectForChangeRequest": "没有可用于此变更请求的活动项目",
  "chat.serverPreviewLoadFailed": "无法加载消息 {messageId} 的服务器预览",
  "chat.revertFailed": "无法回退任务状态",
  "chat.revertRefreshFailed": "工作区已恢复，但刷新失败",
  "chat.selectBaseBranch": "在新建工作树模式下发送前请选择基准分支",
  "chat.sendFailed": "无法发送消息",
  "chat.sendOutcomeUnknown":
    "发送结果未知，Provider 可能已经收到。请先检查任务历史，再决定是否重发，以免出现重复内容。",
  "chat.historyUnavailable": "暂时无法读取 Provider 历史。请重新打开或刷新任务后重试。",
  "chat.providerUnavailable": "此 Provider 暂不支持 Native 任务。",
  "chat.nativeImageMimeUnsupported": "Claude Native 不支持此图片格式。",
  "chat.interruptFailed": "无法中断当前轮次",
  "chat.approvalSubmitFailed": "无法提交审批决定",
  "chat.inputSubmitFailed": "无法提交用户输入",
  "chat.planFollowUpFailed": "无法发送计划后续消息",
  "chat.implementationCreateFailed": "创建新任务时发生错误",
  "chat.switchBranchDescription": "你有未提交的更改，它们会带到其他分支；如发生冲突则会阻止切换",
  "chat.switchBranch": "切换分支",
  "root.showErrorDetails": "显示错误详情",
  "root.hideErrorDetails": "隐藏错误详情",
  "root.keybindingsUpdated": "快捷键已更新",
  "root.keybindingsReloaded": "快捷键配置已成功重新加载",
  "root.keybindingsInvalid": "快捷键配置无效",
  "root.openKeybindings": "打开 keybindings.json",
  "root.openKeybindingsFailed": "无法打开快捷键文件",
  "root.unexpectedRouterError": "发生意外的路由错误",
  "root.noAdditionalErrorDetails": "没有更多错误详情",
  "root.unknownFileOpenError": "打开文件时发生未知错误",
  "git.publishRepository": "发布仓库",
  "git.publishFailed": "发布失败",
  "git.remote": "远程仓库",
  "git.private": "私有",
  "git.privateDescription": "仅受邀人员可访问",
  "git.public": "公开",
  "git.publicDescription": "所有人均可在网页上访问",
  "git.linkUnavailable": "无法打开链接",
  "git.noOpenPullRequest": "未找到打开的拉取请求",
  "git.openPullRequestFailed": "无法打开拉取请求链接",
  "git.waitingForGit": "正在等待 Git…",
  "git.actionFailed": "操作失败",
  "git.pulling": "正在拉取…",
  "git.pullFailed": "拉取失败",
  "git.editorUnavailable": "编辑器不可用",
  "git.openFileFailed": "无法打开文件",
  "git.initializationFailed": "Git 初始化失败",
  "git.actions": "Git 操作",
  "git.options": "Git 操作选项",
  "git.branch": "分支",
  "git.defaultRefWarning": "警告：默认引用",
  "git.files": "文件",
  "git.none": "无",
  "git.excluded": "已排除",
  "git.commitMessageOptional": "提交说明（可选）",
  "git.commitMessagePlaceholder": "留空可自动生成",
  "git.providerStatusUnavailable": "Provider 状态不可用，请打开“设置 → 源代码管理”并重新扫描",
  "git.providerNotAuthenticated": "{provider} 尚未认证，请打开“设置 → 源代码管理”查看配置指引",
  "git.runningSeconds": "已运行 {seconds} 秒",
  "git.runningMinutes": "已运行 {minutes} 分 {seconds} 秒",
  "git.actionInProgress": "Git 操作正在进行",
  "git.statusUnavailable": "Git 状态不可用",
  "git.cleanWorktree": "工作树没有更改，请先修改内容再提交",
  "git.commitUnavailable": "当前无法提交",
  "git.detachedBeforePush": "当前处于 Detached HEAD，请先检出引用再推送",
  "git.commitOrStash": "请先提交或暂存本地更改再推送",
  "git.behindBeforePush": "分支落后于上游，请先拉取或变基再推送",
  "git.addOriginBeforePush": "请先添加 origin 远程仓库再推送",
  "git.noCommitsToPush": "没有可推送的本地提交",
  "git.pushUnavailable": "当前无法推送",
  "git.viewChangeRequestUnavailable": "当前无法查看{name}",
  "git.detachedBeforeChangeRequest": "当前处于 Detached HEAD，请先检出引用再创建{name}",
  "git.commitBeforeChangeRequest": "请先提交本地更改再创建{name}",
  "git.addOriginBeforeChangeRequest": "请先添加 origin 远程仓库再创建{name}",
  "git.noCommitsForChangeRequest": "没有可加入{name}的本地提交",
  "git.behindBeforeChangeRequest": "分支落后于上游，请先拉取或变基再创建{name}",
  "git.createChangeRequestUnavailable": "当前无法创建{name}",
  "git.commitChanges": "提交更改",
  "git.commitDialogDescription": "检查并确认提交，提交说明留空时将自动生成",
  "git.setupRequired": "需要设置",
  "git.configureProvider": "请打开“设置 → 源代码管理”配置此 Provider",
  "git.repositoryPublished": "仓库已发布",
  "git.repositoryCreated": "仓库已创建",
  "git.branchLive": "{branch} 已发布到 {provider}",
  "git.remoteReady": "远程仓库“{remote}”已设置，请提交并推送代码以分享",
  "git.actionUnavailable": "当前无法执行此操作",
  "git.runningAction": "正在执行 Git 操作…",
  "git.runningHook": "正在运行 {hook}…",
  "git.committing": "正在提交…",
  "git.pulled": "已拉取",
  "git.alreadyUpToDate": "已经是最新状态",
  "git.updatedFrom": "已从 {upstream} 更新 {ref}",
  "git.alreadySynchronized": "{ref} 已同步",
  "git.initializing": "正在初始化…",
  "git.initialize": "初始化 Git",
  "git.runOnDefaultRef": "要在默认引用上执行操作吗？",
  "git.commit": "提交",
  "git.push": "推送",
  "git.commitAndPush": "提交并推送",
  "git.syncRef": "同步引用",
  "git.pull": "拉取",
  "git.branchDiverged": "分支与上游已分叉，请先变基或合并",
  "git.branchUpToDate": "分支已是最新状态，无需操作",
  "git.preparingFeatureRef": "正在准备功能引用…",
  "git.pushing": "正在推送…",
  "git.generatingCommitMessage": "正在生成提交说明…",
  "git.pullRequest": "拉取请求",
  "git.mergeRequest": "合并请求",
  "git.changeRequest": "变更请求",
  "git.viewName": "查看{name}",
  "git.createName": "创建{name}",
  "git.commitPushAndName": "提交、推送并创建{name}",
  "git.commitPushCreateName": "提交、推送并创建{name}",
  "git.pushCreateName": "推送并创建{name}",
  "git.pushingTo": "正在推送到 {target}…",
  "git.preparingName": "正在准备{name}…",
  "git.generatingNameContent": "正在生成{name}内容…",
  "git.creatingName": "正在创建{name}…",
  "git.createRefFirst": "请先创建并检出引用，再推送或打开{name}",
  "git.commitPushTo": "提交并推送到 {branch}",
  "git.pushTo": "推送到 {branch}",
  "git.commitPushDefaultTitle": "要提交并推送到默认引用吗？",
  "git.pushDefaultTitle": "要推送到默认引用吗？",
  "git.commitPushCreateDefaultTitle": "要从默认引用提交、推送并创建{name}吗？",
  "git.pushCreateDefaultTitle": "要从默认引用推送并创建{name}吗？",
  "git.commitPushDefaultDescription":
    "此操作会在“{branch}”上提交并推送更改，你可以继续使用此引用，也可以创建功能引用并在那里执行相同操作",
  "git.pushDefaultDescription":
    "此操作会在“{branch}”上推送本地提交，你可以继续使用此引用，也可以创建功能引用并在那里执行相同操作",
  "git.commitPushCreateDefaultDescription":
    "此操作会在“{branch}”上提交、推送并创建{name}，你可以继续使用此引用，也可以创建功能引用并在那里执行相同操作",
  "git.pushCreateDefaultDescription":
    "此操作会在“{branch}”上推送本地提交并创建{name}，你可以继续使用此引用，也可以创建功能引用并在那里执行相同操作",
  "palette.ariaLabel": "命令面板",
  "palette.searchAll": "搜索命令、项目和任务…",
  "palette.search": "搜索…",
  "palette.projects": "项目",
  "palette.threads": "任务",
  "palette.directories": "目录",
  "palette.actions": "操作",
  "palette.recentThreads": "最近任务",
  "palette.environments": "环境",
  "palette.sources": "来源",
  "palette.selectCloneDestination": "选择克隆位置",
  "palette.noActions": "没有匹配的操作",
  "palette.noResults": "没有匹配的命令、项目或任务",
  "palette.unableToBrowseProjects": "无法浏览项目",
  "palette.noEnvironmentAvailable": "没有可用环境",
  "palette.newThreadIn": "在 {project} 中新建任务",
  "palette.newThreadInEllipsis": "在…中新建任务",
  "palette.addProject": "添加项目",
  "palette.openWslFolder": "打开 WSL 文件夹",
  "palette.createAndClone": "创建并克隆",
  "palette.clone": "克隆",
  "palette.createAndAdd": "创建并添加",
  "palette.add": "添加",
  "palette.working": "处理中",
  "palette.lookup": "查找",
  "palette.cloning": "正在克隆",
  "palette.repository": "仓库",
  "palette.enterGitUrl": "输入 Git 克隆 URL 后按 Enter 继续",
  "palette.enterRepositoryPath": "输入仓库路径后按 Enter 查找",
  "palette.chooseDestination": "选择目标路径后按 Enter 克隆",
  "palette.relativePathsRequireProject": "相对路径需要活动项目",
  "palette.createFolderAndAdd": "按 Enter 创建此文件夹并添加为项目",
  "palette.navigate": "导航",
  "palette.select": "选择",
  "palette.openIn": "在 {name} 中打开",
  "sidebar.pathCopied": "已复制路径",
  "sidebar.copyPathFailed": "无法复制路径",
  "sidebar.projectTitleRequired": "项目名称不能为空",
  "sidebar.renameProjectFailed": "无法重命名项目",
  "sidebar.threadTitleRequired": "任务名称不能为空",
  "sidebar.renameThreadFailed": "无法重命名任务",
  "sidebar.settleFailed": "无法标记任务为已处理",
  "sidebar.unsettleFailed": "无法标记任务为待处理",
  "sidebar.wakeFailed": "无法唤醒任务",
  "sidebar.snoozeFailed": "无法稍后处理任务",
  "sidebar.snoozedUntil": "已稍后处理至 {time}",
  "sidebar.undo": "撤销",
  "sidebar.deleteThreadsFailed": "无法删除任务",
  "sidebar.createThreadFailed": "无法创建任务",
  "sidebar.deleteThreadFailed": "无法删除任务",
  "sidebar.deleteThreadsConfirm": "删除 {count} 个任务？",
  "sidebar.removeProjectWithThreadsConfirm": "移除项目“{title}”并删除其中的 {count} 个任务？",
  "sidebar.deleteThreadsProviderImpact":
    "此操作将永久删除这些任务拥有的 Provider 对话，并清除其任务记录。",
  "sidebar.deleteThreadConfirm":
    "删除任务“{title}”？\n此操作将永久删除原 Provider 对话，并清除此任务记录",
  "sidebar.deleteThisThreadConfirm":
    "删除此任务？\n此操作将永久删除原 Provider 对话，并清除此任务记录",
  "sidebar.snooze.inOneHour": "1 小时后",
  "sidebar.snooze.thisEvening": "今晚",
  "sidebar.snooze.tomorrow": "明天",
  "sidebar.snooze.nextWeek": "下周",
  "sidebar.snooze.now": "现在",
  "settings.title": "设置",
  "settings.restoreDefaults": "恢复默认设置",
  "settings.appearance": "外观",
  "settings.theme": "主题",
  "settings.appearanceDescription": "选择 So Code 在应用中的显示外观",
  "settings.projectGrouping": "项目分组",
  "settings.projectGroupingDescription": "合并不同环境中的同一仓库",
  "settings.providerUpdates": "Provider 更新检查",
  "settings.providerUpdatesDescription": "检查已安装的 Provider CLI 是否有可用的新版本",
  "settings.newThreads": "新建任务",
  "settings.archiveConfirmation": "归档确认",
  "settings.deleteConfirmation": "删除确认",
  "settings.providers": "Providers",
  "settings.general": "常规",
  "settings.keybindings": "快捷键",
  "settings.sourceControl": "源代码管理",
  "settings.connections": "连接",
  "settings.beta": "测试功能",
  "settings.archive": "归档",
  "settings.back": "返回",
  "settings.resetToDefault": "恢复默认值",
  "settings.resetLabelToDefault": "将{label}恢复为默认值",
  "settings.restoreDefaultsConfirmTitle": "恢复默认设置？",
  "settings.restoreDefaultsConfirmDescription": "将恢复以下设置：{labels}",
  "settings.theme.system": "跟随系统",
  "settings.theme.light": "浅色",
  "settings.theme.dark": "深色",
  "settings.glassOpacity": "玻璃透明度",
  "settings.glassOpacityDescription":
    "调整玻璃材质界面的透明度。数值越高，菜单、对话框和输入区越不透明",
  "settings.environmentIdentification": "环境标识",
  "settings.environmentIdentificationDescription": "选择 Dev 和 Nightly 环境的标识方式",
  "settings.environmentIdentification.artwork": "主题图",
  "settings.environmentIdentification.pill": "版本标签",
  "settings.environmentIdentification.none": "不显示",
  "settings.wordWrap": "自动换行",
  "settings.wordWrapDescription": "默认对代码块、表格、差异和文件预览中的长行自动换行",
  "settings.general.timeFormat": "时间格式",
  "settings.general.timeFormatDescription": "跟随浏览器或操作系统的时钟格式设置",
  "settings.general.timestampFormat": "时间格式",
  "settings.general.timestampFormat.locale": "跟随系统",
  "settings.general.timestampFormat.12Hour": "12 小时制",
  "settings.general.timestampFormat.24Hour": "24 小时制",
  "settings.general.hideWhitespaceChanges": "隐藏空白字符变更",
  "settings.general.hideWhitespaceChangesDescription":
    "设置差异面板是否默认忽略仅包含空白字符的更改",
  "settings.general.assistantOutput": "助手输出",
  "settings.general.assistantOutputDescription": "在回复生成过程中逐字显示输出",
  "settings.general.autoOpenPlanSidebar": "自动打开计划侧边栏",
  "settings.general.autoOpenPlanSidebarDescription":
    "规划模式生成 Markdown 提案时自动打开计划侧边栏",
  "settings.general.newThreadsDescription": "选择新建草稿任务默认使用的工作区模式",
  "settings.general.defaultThreadMode": "默认任务模式",
  "settings.general.local": "本地",
  "settings.general.newWorktree": "新建工作树",
  "settings.general.startFromOrigin": "从 origin 开始",
  "settings.general.startFromOriginDescription":
    "从 origin 上最新的匹配分支创建工作树，而不是使用本地分支",
  "settings.general.addProjectStartsIn": "添加项目时的起始目录",
  "settings.general.addProjectStartsInDescription": "留空时，添加项目浏览器将从“~/”开始",
  "settings.general.archiveConfirmationDescription": "归档任务前，需要再次点击行内归档操作进行确认",
  "settings.general.deleteConfirmationDescription": "删除任务及其聊天记录前进行确认",
  "settings.general.textGenerationModel": "文本生成模型",
  "settings.general.textGenerationModelDescription":
    "用于生成任务标题和源代码管理内容等文本的默认模型。源代码管理设置可通过专用写作模型覆盖此选项",
  "settings.about": "关于",
  "settings.version": "版本",
  "settings.currentVersionDescription": "当前应用版本",
  "settings.updateAvailable": "有可用更新",
  "settings.updateTrackDescription":
    "Stable 跟随正式版本；Nightly 跟随桌面端夜间构建通道，并可随时切回 Stable",
  "settings.hostedUpdateTrackDescription": "切换托管应用的发布通道",
  "settings.stable": "Stable",
  "settings.nightly": "Nightly",
  "settings.latest": "最新",
  "settings.diagnostics": "诊断",
  "settings.viewDiagnostics": "查看诊断",
  "diagnostics.noTraceRecords": "没有追踪记录",
  "diagnostics.detailsFor": "{label}详情",
  "diagnostics.showFullError": "显示完整错误",
  "diagnostics.showFullMessage": "显示完整消息",
  "diagnostics.showLess": "收起",
  "diagnostics.traceId": "追踪 ID",
  "diagnostics.copiedTraceId": "已复制追踪 ID",
  "diagnostics.copyTraceId": "复制追踪 ID",
  "diagnostics.copied": "已复制",
  "diagnostics.copyFullTraceId": "复制完整追踪 ID",
  "diagnostics.subprocess": "子进程",
  "diagnostics.agent": "智能体",
  "diagnostics.process": "进程",
  "diagnostics.collapse": "收起 {name}",
  "diagnostics.expand": "展开 {name}",
  "diagnostics.sendSigint": "发送 SIGINT",
  "diagnostics.sendSigkill": "发送 SIGKILL",
  "diagnostics.name": "名称",
  "diagnostics.memory": "内存",
  "diagnostics.command": "命令",
  "diagnostics.type": "类型",
  "diagnostics.kill": "终止",
  "diagnostics.noLiveDescendantProcesses": "未找到正在运行的子进程",
  "diagnostics.root": "根",
  "diagnostics.child": "子",
  "diagnostics.processAria": "{role}进程 {name}",
  "diagnostics.cpuChartAria": "平均 CPU {average}%，峰值 CPU {peak}%",
  "diagnostics.cpuChartTooltip": "平均 {average}%，峰值 {peak}%",
  "diagnostics.cpuTime": "CPU 时间",
  "diagnostics.current": "当前",
  "diagnostics.average": "平均",
  "diagnostics.peak": "峰值",
  "diagnostics.maxMemory": "最大内存",
  "diagnostics.checking": "正在检查",
  "diagnostics.checkedUnavailable": "检查时间不可用",
  "diagnostics.checkedWithSuffix": "检查于 {value} {suffix}",
  "diagnostics.checked": "检查于 {value}",
  "diagnostics.noAvailableEditors": "未找到可用编辑器",
  "diagnostics.noEnvironmentSelected": "未选择环境",
  "diagnostics.unableToOpenLogsFolder": "无法打开日志文件夹",
  "diagnostics.confirmSigkill": "向进程 {pid} 发送 SIGKILL？进程无法处理此信号",
  "diagnostics.couldNotSendSignal": "无法发送 {signal}",
  "diagnostics.failedToSendSignal": "发送 {signal} 失败",
  "diagnostics.processAlreadyExited": "进程已退出",
  "diagnostics.processNotChild": "该进程不是 So Code server 的子进程，可能已经退出",
  "diagnostics.liveProcesses": "实时进程",
  "diagnostics.refreshProcessDiagnostics": "刷新进程诊断",
  "diagnostics.childProcesses": "子进程",
  "diagnostics.childCpuTooltip":
    "当前服务器进程及其正在运行的子进程占用的 CPU 总量，不包括桌面壳层和其他父进程",
  "diagnostics.childMemoryTooltip":
    "当前服务器进程及其正在运行的子进程占用的驻留内存总量，不包括桌面壳层和其他父进程",
  "diagnostics.serverPid": "服务器 PID",
  "diagnostics.loadingLiveProcesses": "正在加载实时进程…",
  "diagnostics.resourceHistory": "资源历史",
  "diagnostics.refreshResourceHistory": "刷新资源历史",
  "diagnostics.cpuTimeTooltip":
    "所选时间范围内 So Code server 根进程及其子进程的近似活跃 CPU 时间，仅在采样进程使用 CPU 时增长，时间窗口移动后旧样本会退出统计",
  "diagnostics.samples": "样本",
  "diagnostics.samplesTooltip": "服务器保留在内存中的进程样本，服务器重启后会重置",
  "diagnostics.interval": "间隔",
  "diagnostics.processes": "进程数",
  "diagnostics.collectingResourceSamples": "正在收集进程资源样本…",
  "diagnostics.noResourceSamples": "此时间范围内未找到进程资源样本",
  "diagnostics.traceDiagnostics": "追踪诊断",
  "diagnostics.openLogsFolder": "打开日志文件夹",
  "diagnostics.refreshTraceDiagnostics": "刷新追踪诊断",
  "diagnostics.spans": "跨度",
  "diagnostics.failures": "失败",
  "diagnostics.slowSpans": "慢跨度",
  "diagnostics.slowSpansTooltip": "持续时间达到 {duration} 或更长的跨度",
  "diagnostics.slowSpansTooltipFallback": "达到或超过已配置慢跨度阈值的跨度",
  "diagnostics.parseErrors": "解析错误",
  "diagnostics.partialTraceRead": "部分追踪文件无法读取，诊断结果可能不完整 {error}",
  "diagnostics.latestFailures": "最近失败",
  "diagnostics.span": "跨度",
  "diagnostics.cause": "原因",
  "diagnostics.duration": "耗时",
  "diagnostics.ended": "结束时间",
  "diagnostics.loadingFailures": "正在加载失败记录…",
  "diagnostics.noFailedSpans": "未找到失败跨度",
  "diagnostics.mostCommonFailures": "最常见失败",
  "diagnostics.count": "次数",
  "diagnostics.lastSeen": "最后出现",
  "diagnostics.loadingFailureGroups": "正在加载失败分组…",
  "diagnostics.noRepeatedFailures": "未找到重复失败",
  "diagnostics.slowestSpans": "最慢跨度",
  "diagnostics.trace": "追踪",
  "diagnostics.loadingSlowSpans": "正在加载慢跨度…",
  "diagnostics.noSpans": "未找到跨度",
  "diagnostics.spanLogs": "跨度日志",
  "diagnostics.time": "时间",
  "diagnostics.level": "级别",
  "diagnostics.message": "消息",
  "diagnostics.loadingRecentLogs": "正在加载最近日志…",
  "diagnostics.noWarningsOrErrors": "未找到警告或错误",
  "diagnostics.topSpanNames": "出现最多的跨度名称",
  "diagnostics.max": "最大值",
  "diagnostics.loadingSpanNames": "正在加载跨度名称…",
  "settings.updateTrackChangeFailed": "无法切换更新通道",
  "settings.updateTrackChangeFailedDescription": "切换更新通道失败",
  "settings.downloadFailedDescription": "下载失败",
  "settings.installFailedDescription": "安装失败",
  "settings.updateCheckFailedDescription": "检查更新失败",
  "settings.automaticUpdatesUnavailable": "此构建不支持自动更新",
  "settings.restoreLabel.visibleThreads": "可见任务数",
  "settings.restoreLabel.diffWhitespaceChanges": "空白字符变更",
  "settings.restoreLabel.automaticGitFetchInterval": "自动 Git 拉取间隔",
  "settings.restoreLabel.newThreadMode": "新建任务模式",
  "settings.restoreLabel.newWorktreesStartFromOrigin": "新建工作树从 origin 开始",
  "settings.restoreLabel.addProjectBaseDirectory": "添加项目起始目录",
  "settings.addProvider": "添加 Provider 实例",
  "settings.keybindings.search": "搜索快捷键",
  "settings.keybindings.unknownCondition": "未知条件：{identifier}",
  "settings.keybindings.unknownConditions": "未知条件：{identifiers}",
  "settings.keybindings.unknownConditionDescription":
    "So Code 尚无法识别此条件。仍可保存，但除非运行时提供该条件，否则它可能不会匹配",
  "settings.keybindings.conflictsWith": "与 {labels} 冲突",
  "settings.keybindings.conflictsWithMore": "与 {labels} 等冲突",
  "settings.keybindings.conflictResolution": "当两个条件都适用时，最近匹配的绑定优先",
  "settings.keybindings.condition": "条件",
  "settings.keybindings.negateCondition": "取反 {condition}",
  "settings.keybindings.negateGroup": "对分组取反",
  "settings.keybindings.removeCondition": "移除条件",
  "settings.keybindings.removeNegatedGroup": "移除取反分组",
  "settings.keybindings.addCondition": "条件",
  "settings.keybindings.addGroup": "分组",
  "settings.keybindings.removeGroup": "移除分组",
  "settings.keybindings.when": "条件",
  "settings.keybindings.always": "始终",
  "settings.keybindings.whenExpression": "条件表达式",
  "settings.keybindings.fixExpression": "请先修正上方表达式，再继续可视化编辑",
  "settings.keybindings.editShortcut": "编辑 {command} 的快捷键",
  "settings.keybindings.edit": "编辑",
  "settings.keybindings.keybindingFor": "{command} 的快捷键",
  "settings.keybindings.pressShortcut": "请按下快捷键",
  "settings.keybindings.unassigned": "未分配",
  "settings.keybindings.saving": "保存中",
  "settings.keybindings.save": "保存",
  "settings.keybindings.editWhenClause": "编辑 {command} 的条件子句",
  "settings.keybindings.actionsFor": "{command} 的操作",
  "settings.keybindings.resetToDefault": "恢复默认值",
  "settings.keybindings.remove": "移除",
  "settings.keybindings.newKeybinding": "新快捷键",
  "settings.keybindings.command": "命令",
  "settings.keybindings.keybinding": "快捷键",
  "settings.keybindings.status": "状态",
  "settings.keybindings.noMatches": "没有与搜索相符的快捷键",
  "settings.keybindings.count": {
    other: "{count} 个快捷键",
  },
  "settings.keybindings.add": "添加快捷键",
  "settings.keybindings.openFile": "打开 keybindings.json",
  "settings.keybindings.webWarning":
    "部分快捷键可能会在 So Code 接收到前被浏览器占用。请使用桌面应用以获得更好的快捷键支持",
  "settings.keybindings.cancelNew": "取消新建快捷键",
  "settings.keybindings.cancel": "取消",
  "settings.keybindings.openFileFailed": "无法打开快捷键文件",
  "settings.keybindings.openFileFailedDescription": "未能打开快捷键文件",
  "settings.keybindings.saveFailed": "无法保存快捷键",
  "settings.keybindings.saveFailedDescription": "未能保存快捷键",
  "settings.keybindings.removeFailed": "无法移除快捷键",
  "settings.keybindings.removeFailedDescription": "未能移除快捷键",
  "settings.keybindings.not": "非",
  "settings.keybindings.and": "且",
  "settings.keybindings.or": "或",
  "settings.beta.features": "测试功能",
  "settings.beta.sidebarV2": "新版侧边栏",
  "settings.beta.sidebarV2Description":
    "按创建顺序显示的单一任务列表。进行中的任务显示为信息卡片，已完成任务收起为紧凑行。自动收起需要最新服务器；旧服务器上的任务会保持进行中。可随时切换回来",
  "settings.beta.enableSidebarV2": "启用新版侧边栏测试功能",
  "settings.beta.autoSettle": "自动收起不活跃任务",
  "settings.beta.autoSettleDescription":
    "在此时长内没有活动的任务会自动收起。关联已合并或已关闭 PR 的任务始终会收起",
  "settings.beta.autoSettleAria": "自动收起不活跃任务",
  "settings.beta.autoSettleDays": "自动收起前的不活跃天数",
  "settings.beta.autoSettleDaysDescription": "任何新的活动都会自动恢复任务",
  "settings.archive.unarchive": "取消归档",
  "settings.archive.delete": "删除",
  "settings.archive.unarchiveFailed": "无法取消归档任务",
  "settings.archive.deleteFailed": "无法删除任务",
  "settings.archive.actionFailed": "已归档任务操作失败",
  "settings.archive.genericError": "发生错误",
  "settings.archive.title": "已归档任务",
  "settings.archive.loading": "正在加载已归档任务",
  "settings.archive.loadFailed": "无法加载已归档任务",
  "settings.archive.empty": "没有已归档任务",
  "settings.archive.checking": "正在检查已连接环境",
  "settings.archive.emptyDescription": "已归档任务将显示在这里",
  "settings.archive.actionContext": "归档于 {archivedAt} · 创建于 {createdAt}",
  "provider.wizard.driver": "驱动",
  "provider.wizard.identity": "标识",
  "provider.wizard.config": "配置",
  "provider.wizard.step": "{step}，第 {number} 步",
  "provider.labelPlaceholder": "例如：工作",
  "provider.optionalPickerMarker": "可选；显示在选择器中的标记",
  "provider.noRequiredConfiguration": "此驱动没有必填配置，可以直接添加实例",
  "provider.addInstance": "添加实例",
  "provider.instanceIdRequired": "实例 ID 为必填项",
  "provider.instanceExists": "名为“{id}”的实例已存在",
  "provider.instanceAdded": "Provider 实例已添加",
  "provider.instanceAddFailed": "无法添加 Provider 实例",
  "provider.instanceIdTooLong": "实例 ID 最多 64 个字符",
  "provider.instanceIdInvalid": "实例 ID 必须以字母开头，且只能包含字母、数字、“-”或“_”",
  "provider.instanceAddedDescription": "已添加 {driver} 实例“{id}”",
  "provider.environmentVariables": "环境变量",
  "provider.variable": "变量",
  "provider.value": "值",
  "provider.sensitive": "敏感",
  "provider.options": "选项",
  "provider.storedSecret": "已保存密钥；输入新值即可替换",
  "provider.deleteInstance": "删除实例",
  "provider.authenticatedAs": "已认证为",
  "provider.email": "邮箱",
  "provider.updating": "正在更新",
  "provider.updateNow": "立即更新",
  "provider.copyUpdateCommand": "复制更新命令",
  "provider.copyCommand": "复制命令",
  "provider.modelsAvailable": "{count} 个可用模型",
  "provider.addFavorite": "添加到收藏",
  "provider.removeFavorite": "从收藏中移除",
  "provider.moveUp": "上移",
  "provider.moveDown": "下移",
  "provider.showInPicker": "在选择器中显示",
  "provider.hideFromPicker": "从选择器中隐藏",
  "provider.enterModelSlug": "请输入模型 slug",
  "provider.updateFailed": "更新失败",
  "provider.useAccent": "使用 {color} 作为强调色",
  "provider.models": "模型",
  "provider.modelAvailable": "{count} 个可用模型",
  "provider.fastMode": "快速模式",
  "provider.thinking": "思考",
  "provider.reasoning": "推理",
  "provider.detailsFor": "{name} 的详情",
  "provider.hidden": "已隐藏",
  "provider.custom": "自定义",
  "provider.favoriteAction": "{action} {name}{place}收藏",
  "provider.add": "添加",
  "provider.remove": "移除",
  "provider.from": "从",
  "provider.to": "到",
  "provider.show": "显示",
  "provider.hide": "隐藏",
  "provider.removeCustomModel": "移除自定义模型",
  "provider.modelBuiltIn": "该模型已内置",
  "provider.modelSlugTooLong": "模型 slug 最多 {count} 个字符",
  "provider.customModelSaved": "该自定义模型已保存",
  "sourceControl.serverEnvironment": "服务器环境",
  "sourceControl.versionControl": "版本控制",
  "sourceControl.providers": "代码托管平台",
  "sourceControl.authenticated": "已认证",
  "sourceControl.notAuthenticated": "未认证",
  "sourceControl.statusUnknown": "状态未知",
  "sourceControl.fetchInterval": "拉取间隔",
  "sourceControl.seconds": "秒",
  "sourceControl.scanFailed": "无法扫描服务器环境",
  "sourceControl.nothingDetected": "尚未检测到工具",
  "sourceControl.rescan": "重新扫描服务器环境",
  "sourceControl.textGeneration": "文本生成",
  "sourceControl.writingStyle": "源代码管理写作风格",
  "sourceControl.repositoryConventions": "仓库惯例",
  "sourceControl.customInstructions": "自定义说明",
  "sourceControl.followTemplates": "遵循变更请求模板",
  "sourceControl.writerModel": "源代码管理写作模型",
  "sourceControl.repositoryConventionsDescription": "在每个项目中，匹配近期变更说明和变更请求标题",
  "sourceControl.conventionalCommitsDescription":
    "变更说明使用 Conventional Commit 前缀；变更请求标题和说明保持简洁",
  "sourceControl.customInstructionsDescription":
    "在每个项目中，将你的说明应用到变更说明和变更请求的标题与说明",
  "sourceControl.customInstructionsPlaceholder": "标题保持简洁。说明中使用简短的项目符号",
  "sourceControl.followTemplatesDescription": "若当前仓库有模板，则使用该模板组织变更请求说明",
  "sourceControl.changeRequestTemplates": "变更请求模板",
  "sourceControl.writerModelDescription":
    "可选：为变更说明、变更请求标题和说明、分支或 bookmark 名称指定模型。关闭时使用全局文本生成模型",
  "sourceControl.useDedicatedWriterModel": "使用独立的源代码管理写作模型",
  "sourceControl.toggleAccountVisibility": "切换代码托管账号可见性",
  "sourceControl.revealAccount": "点击显示账号",
  "sourceControl.hideAccount": "点击隐藏账号",
  "sourceControl.fetchIntervalDescription":
    "在后台刷新远程分支状态。如果 Git 凭据或安全密钥只应在明确执行 Git 操作时提示，请设为 0 秒",
  "sourceControl.decreaseFetchInterval": "缩短拉取间隔",
  "sourceControl.fetchIntervalInSeconds": "Git 自动拉取间隔（秒）",
  "sourceControl.increaseFetchInterval": "延长拉取间隔",
  "sourceControl.nothingDetectedDescription":
    "请在服务器上安装 Git，按需添加代码托管集成或工作区所需凭据，然后重新扫描",
  "sourceControl.scan": "扫描",
  "sourceControl.rescanDescription": "重新扫描 Git 和代码托管集成",
  "provider.addEnvironmentVariable": "添加",
  "provider.environmentVariablesDescription":
    "添加变量以传递 API 密钥、基础 URL 或其他每实例 CLI 设置",
  "provider.sensitiveValuesDescription": "敏感值会单独保存，保存后不会返回到应用",
  "provider.toggleEmailVisibility": "切换账号邮箱可见性",
  "provider.revealEmail": "点击显示邮箱",
  "provider.hideEmail": "点击隐藏邮箱",
  "provider.deleteInstanceAria": "删除 Provider 实例 {id}",
  "provider.updateAvailableDetails": "有可用更新——查看详情",
  "provider.updateAvailable": "有可用更新",
  "provider.toggleDetails": "切换 {name} 的详情",
  "provider.enable": "启用 {name}",
  "provider.instanceLabel": "实例标签",
  "provider.optionalListLabel": "可选标签，显示在 Provider 列表中",
  "provider.accentDescription": "用于在选择器栏和模型列表中区分此实例",
  "provider.updateCommandCopied": "已复制 {name} 更新命令",
  "provider.runInTerminal": "准备更新时，请在终端中运行",
  "provider.copyUpdateCommandFailed": "无法复制 {name} 更新命令",
  "connections.viewEnvironment": "查看环境",
  "connections.viewEnvironmentDescription": "查看任务、状态、差异和配置",
  "connections.operateTasks": "操作任务",
  "connections.operateTasksDescription": "启动任务并在环境中进行更改",
  "connections.useTerminals": "使用终端",
  "connections.useTerminalsDescription": "创建终端并向运行中的 shell 发送输入",
  "connections.writeReviews": "编写审查意见",
  "connections.writeReviewsDescription": "审查更改时创建评论",
  "connections.viewAccess": "查看访问权限",
  "connections.viewAccessDescription": "查看配对链接和已授权客户端",
  "connections.manageAccess": "管理访问权限",
  "connections.manageAccessDescription": "为其他客户端签发和撤销凭据",
  "connections.viewRelay": "查看中继",
  "connections.viewRelayDescription": "查看托管中继连接状态",
  "connections.manageRelay": "管理中继",
  "connections.manageRelayDescription": "更改托管隧道的连接状态",
  "connections.grantedScopes": "已授予权限范围",
  "connections.scopeCount": "{count} 个权限范围",
  "connections.showScopes": "{label}：显示 {count}",
  "connections.t3Connect": "T3 Connect",
  "connections.enableT3Connect": "启用 T3 Connect",
  "connections.signInT3Connect": "登录 T3 Connect 以管理此环境",
  "connections.noManageT3Connect": "当前会话无权管理 T3 Connect 访问权限",
  "connections.t3ConnectLinked": "T3 Connect 已连接",
  "connections.tunnelDisabled": "T3 Connect 隧道已停用",
  "connections.t3ConnectUnlinked": "T3 Connect 已解除连接",
  "connections.t3ConnectAvailable": "此环境可通过 T3 Connect 访问",
  "connections.t3ConnectUnavailable": "此环境已无法通过 T3 Connect 访问",
  "connections.tunnelRemovedActivityOn": "托管隧道已移除，Agent 活动发布仍保持开启",
  "connections.agentActivityEnabled": "Agent 活动已启用",
  "connections.agentActivityDisabled": "Agent 活动已停用",
  "connections.agentActivityEnabledDescription": "此环境会向移动端客户端发布 Agent 活动",
  "connections.agentActivityDisabledDescription": "此环境将停止发布 Agent 活动",
  "connections.t3ConnectOnDescription": "此环境可通过 T3 Connect 供你的其他设备访问",
  "connections.t3ConnectOffDescription": "让你的其他设备可通过 T3 Connect 访问此环境",
  "connections.publishAgentActivity": "发布 Agent 活动",
  "connections.publishAgentActivityDescription":
    "向移动端客户端发送此环境的活动，用于推送通知和实时活动；无需 T3 Connect 隧道也可使用",
  "connections.publishAgentActivityAria": "向移动端客户端发布 Agent 活动",
  "connections.noRemoteEnvironments": "尚未保存远程环境",
  "connections.noRemoteEnvironmentsWithCloud":
    "点击“添加环境”以配对其他环境，或从 T3 Connect 连接环境",
  "connections.noRemoteEnvironmentsWithoutCloud": "点击“添加环境”以配对其他环境",
  "settings.refreshProviders": "刷新 Provider 状态",
  "provider.addTitle": "添加 Provider 实例",
  "provider.addDescription": "配置额外的 Provider 实例，例如将第二个 Codex 安装指向其他工作区",
  "provider.driver": "驱动",
  "provider.label": "标签",
  "provider.instanceId": "实例 ID",
  "provider.accentColor": "强调色",
  "provider.chooseCustomAccent": "为 {name} 选择自定义强调色",
  "provider.clearAccent": "清除 {name} 的强调色",
  "provider.labelDescription": "显示在 Provider 列表中，可选",
  "provider.instanceIdDescription": "任务和会话使用的路由键；仅允许字母、数字、“-”或“_”",
  "provider.comingSoon": "即将推出",
  "provider.clear": "清除",
  "provider.displayName": "显示名称",
  "connections.createPairingLink": "创建配对链接",
  "connections.createPairingDescription": "生成一次性链接，供其他设备将此后端配对为已授权客户端",
  "connections.clientLabel": "客户端标签（可选）",
  "connections.permissions": "权限",
  "connections.tailscaleHttps": "Tailscale HTTPS",
  "connections.networkAccess": "网络访问",
  "connections.authorizedClients": "已授权客户端",
  "connections.remoteEnvironments": "远程环境",
  "connections.addEnvironment": "添加环境",
  "connections.wslBackend": "WSL 后端",
  "connections.wslOnly": "仅 WSL",
  "updates.track": "更新通道",
  "updates.download": "下载",
  "updates.install": "安装",
  "updates.checking": "正在检查…",
  "updates.downloading": "正在下载…",
  "updates.upToDate": "已是最新版本",
  "updates.check": "检查更新",
  "updates.downloadFailed": "无法下载更新",
  "updates.installFailed": "无法安装更新",
  "updates.checkFailed": "无法检查更新",
  "pairing.pendingTitle": "正在与此环境配对",
  "pairing.pendingDescription": "正在验证配对链接并准备会话",
  "pairing.title": "与此环境配对",
  "pairing.token": "配对令牌",
  "pairing.tokenPlaceholder": "粘贴一次性令牌或配对密钥",
  "pairing.inProgress": "正在配对…",
  "pairing.reloadApp": "重新加载应用",
  "pairing.connectingBackend": "正在连接此后端",
  "pairing.missingLink": "此配对链接缺少后端主机或令牌",
  "pairing.tokenAlreadySubmitted": "此一次性配对令牌已提交，请申请新的配对链接",
  "pairing.environmentSaved": "{label} 已保存在此浏览器中",
  "pairing.environmentFallback": "该环境",
  "pairing.retryToken": "{error} 如果后端已接受此一次性令牌，请先申请新的配对链接再重试",
  "pairing.paired": "后端已配对",
  "pairing.failed": "配对失败",
  "pairing.backend": "正在配对后端",
  "pairing.host": "主机",
  "pairing.reachabilityHelp":
    "请确认此浏览器能够访问后端、后端允许托管客户端跨域访问，并且从 HTTPS 页面打开时后端也通过 HTTPS 提供服务",
  "pairing.openApp": "打开应用",
  "pairing.authenticationFailed": "认证失败",
  "pairing.trustedCredential": "连接前，此环境需要可信的配对凭据",
  "pairing.enterToken": "输入配对令牌以开始与此环境的会话",
  "pairing.acceptsDesktopAndToken": "此环境同时接受桌面端管理的配对和一次性配对令牌",
  "pairing.desktopManaged": "此环境由桌面端管理。请从桌面应用打开，或粘贴明确签发的引导凭据",
  "pairing.acceptsToken":
    "此环境接受一次性配对令牌。配对链接可以直接打开此页面，也可以在此处粘贴令牌",
  "ssh.promptFailed": "SSH 密码提示失败",
  "ssh.promptExpired": "此 SSH 密码提示已过期，请重新连接",
  "ssh.expired": "已过期",
  "ssh.dismiss": "关闭",
  "ssh.cancel": "取消",
  "ssh.passwordRequired": "需要 SSH 密码",
  "ssh.passwordDescription":
    "So Code 需要 SSH 密码才能连接到 {target}，密码只会传给本地 SSH 进程完成本次连接，不会由 So Code 保存",
  "ssh.useKeys": "使用 SSH 密钥可避免在新的 SSH 会话中重复输入密码",
  "ssh.continue": "继续",
  "connections.showQrCode": "显示二维码",
  "connections.pairingQrTitle": "配对链接——使用其他设备扫描打开",
  "connections.pairingLinkScopes": "配对链接权限范围",
  "connections.copyTokenPair": "复制令牌，然后使用此后端可访问的主机从其他客户端配对",
  "connections.copySelectedEndpoint": "复制所选端点",
  "connections.copyPairingUrlFor": "复制用于以下地址的配对 URL：{label}",
  "connections.chooseEndpoint": "选择要复制的端点",
  "connections.copyCode": "复制代码",
  "connections.showLink": "显示链接",
  "connections.showCode": "显示代码",
  "connections.hostedAppPairingLink": "托管应用配对链接",
  "connections.pairingLink": "配对链接",
  "connections.pairingCode": "配对码",
  "connections.clipboardHostedUnavailable":
    "此处无法使用剪贴板复制。请在要连接的设备上打开或手动复制此托管应用链接",
  "connections.clipboardPairingUrlUnavailable":
    "此处无法使用剪贴板复制。请在要连接的设备上打开或手动复制完整配对 URL",
  "connections.clipboardCodeUnavailable": "此处无法使用剪贴板复制。请手动将此代码复制到其他客户端",
  "connections.revoking": "正在撤销…",
  "connections.revoke": "撤销",
  "connections.wslLoadFailed": "无法加载 WSL 后端状态",
  "connections.retrying": "正在重试…",
  "connections.retry": "重试",
  "connections.wslUnavailable":
    "WSL 已不可用，因此正在运行 Windows 后端。关闭 WSL 后端以清除此偏好",
  "connections.switchToWindows": "切换到 Windows",
  "connections.off": "关闭",
  "connections.defaultDistro": "默认发行版",
  "connections.wslDescription":
    "在 Windows 后端旁边的 WSL 发行版内运行第二个后端。选择发行版以启动，选择“关闭”以停止。使用 WSL 后端打开的项目位于 Linux 端；Windows 项目保持原位置",
  "connections.wslStartFailed": "WSL 后端无法启动：{error}",
  "connections.defaultSuffix": "（默认）",
  "connections.wslOnlyDescription":
    "停止 Windows 后端，仅运行 WSL 后端。如果你完全在 WSL 中开发且不想要第二个后端进程，此设置很有用。更改后 So Code 会重启",
  "connections.runWslOnly": "仅运行 WSL",
  "connections.tailscaleAvailableDescription":
    "使用 Tailscale Serve 通过 MagicDNS HTTPS URL 暴露此后端",
  "connections.startTailscaleDescription": "启动 Tailscale 以通过 MagicDNS 配置 HTTPS 访问",
  "connections.reachableAt": "可通过 {endpoint} 访问",
  "connections.exposedAllInterfaces": "已在所有网络接口上暴露",
  "connections.limitedThisMachine": "仅限此设备",
  "connections.loading": "正在加载…",
  "connections.remoteAccessConfigured":
    "此后端已配置远程访问。网络暴露设置必须在启动服务器的位置更改",
  "connections.localOnlyRestart": "此后端仅能在本机访问。请使用非 loopback 主机重启以启用远程配对",
  "connections.networkChangesControlled": "网络暴露更改会重启后端，必须在启动服务器进程的位置控制",
  "connections.thisEnvironment": "当前环境",
  "connections.versionDrift": "版本不一致",
  "connections.versionDriftDescription":
    "客户端 {client}，服务器 {server}。如 RPC 调用或重新连接失败，请同步版本",
  "connections.thisServer": "此服务器",
  "common.done": "完成",
  "connections.connectedFor": "已连接 {time}",
  "connections.connected": "已连接",
  "connections.lastConnectedAt": "上次连接于 {time}",
  "connections.notConnectedYet": "尚未连接",
  "connections.thisDevice": "此设备",
  "connections.clientScopes": "客户端权限范围",
  "connections.revokeOthers": "撤销其他客户端",
  "connections.createLink": "创建链接",
  "connections.pairingLabelPlaceholder": "例如：客厅 iPad",
  "connections.permissionLimit": "限制已配对客户端可执行的操作",
  "connections.readOnly": "只读",
  "connections.standard": "标准",
  "connections.selectPermission": "请至少选择一项权限",
  "connections.accessWriteWarning": "此客户端可为其他设备创建或撤销访问权限",
  "connections.creating": "正在创建…",
  "connections.createPairingFailed": "无法创建配对 URL",
  "connections.createPairingFailedDescription": "无法创建配对 URL",
  "connections.enableNetworkTitle": "启用网络访问？",
  "connections.disableNetworkTitle": "停用网络访问？",
  "connections.enableNetworkDescription": "So Code 将重启，以便通过网络暴露此环境",
  "connections.disableNetworkDescription": "So Code 将重启并将此环境限制回本机",
  "connections.restarting": "正在重启…",
  "connections.restartEnable": "重启并启用",
  "connections.restartDisable": "重启并停用",
  "connections.turnOffWsl": "关闭 WSL 并切换回 Windows？",
  "connections.disableWsl": "停用 WSL 后端？",
  "connections.switchWslDistro": "切换 WSL 发行版？",
  "connections.startWsl": "启动 WSL 后端",
  "connections.runOnlyWsl": "仅运行 WSL 后端？",
  "connections.reenableWindows": "重新启用 Windows 后端？",
  "connections.wslSwitchWindowsDescription":
    "So Code 将在 Windows 后端上重启。在 WSL 中打开的任务和项目会安全保留在发行版内，并会在重新启用 WSL 后再次可用",
  "connections.wslDisableDescription":
    "WSL 后端将停止。在 WSL 中打开的任务和项目会安全保留在发行版内，但在重新启用 WSL 前无法在 So Code 中使用",
  "connections.wslDistroChangeDescription":
    "So Code 将在新发行版上重启 WSL 后端。当前发行版中仍在运行的会话将被中断",
  "connections.wslEnableChoice":
    "是在 Windows 后端旁运行 WSL 后端，还是停止 Windows 后端并仅使用 WSL？之后可在设置中更改",
  "connections.wslOnlyDescriptionConfirm":
    "So Code 将重启并仅启动 WSL 后端。Windows 端项目在再次关闭此设置前无法访问",
  "connections.wslReenableWindowsDescription": "So Code 将重启并在 WSL 旁重新启动 Windows 后端",
  "connections.applying": "正在应用…",
  "connections.useOnlyWsl": "仅使用 WSL",
  "connections.runBothBackends": "运行两个后端",
  "connections.disableWslAction": "停用 WSL",
  "connections.switchDistro": "切换发行版",
  "connections.disableTailscale": "停用 Tailscale HTTPS？",
  "connections.disableTailscaleDescription":
    "So Code 将在不使用 Tailscale Serve 的情况下重启本地后端",
  "connections.setupTailscale": "配置 Tailscale HTTPS？",
  "connections.setupTailscaleDescription":
    "So Code 将在启用 Tailscale Serve 后重启本地后端，并请求 Tailscale 将 HTTPS 流量代理到此后端",
  "connections.httpsPort": "HTTPS 端口",
  "connections.invalidHttpsPort": "请输入 1 到 65535 之间的端口",
  "connections.httpsEndpoint": "HTTPS 端点",
  "connections.pendingMagicDns": "等待 MagicDNS 端点",
  "connections.enable": "启用",
  "connections.administrativeAccess": "管理访问权限",
  "connections.administrativeAccessDescription":
    "此后端的配对链接和客户端会话管理需要 access:write 权限范围",
  "settings.providerCheckedUnavailable": "检查时间不可用",
  "settings.providerChecked": "检查于 {time}",
  "sourceControl.comingSoon": "即将支持 {name}",
  "sourceControl.unavailableOnServer": "此服务器上不可用：{hint}",
  "sourceControl.authenticatedAs": "已认证为",
  "sourceControl.availableWithHint": "可用。{hint}",
  "sourceControl.notAuthenticatedOnServer":
    "{name} 尚未在此服务器上认证。请在服务器主机上使用 {command} 工具登录或配置凭据，以启用变更请求功能",
  "sourceControl.verifyFailed": "无法验证 {name}。{hint}",
  "sourceControl.available": "可用",
  "sourceControl.as": "为",
  "connections.searchSshHosts": "搜索主机或输入 devbox",
  "connections.pairAnotherEnvironment": "将其他环境配对到此客户端",
  "connections.networkUpdateFailed": "无法更新网络暴露设置",
  "connections.networkUpdateFailedTitle": "无法更新网络访问",
  "connections.tailscaleSetupFailed": "无法配置 Tailscale HTTPS",
  "connections.tailscaleSetupFailedTitle": "无法配置 Tailscale HTTPS",
  "connections.tailscaleDisableFailed": "无法停用 Tailscale HTTPS",
  "connections.tailscaleDisableFailedTitle": "无法停用 Tailscale HTTPS",
  "connections.revokePairingFailed": "无法撤销配对链接",
  "connections.revokePairingFailedTitle": "无法撤销配对链接",
  "connections.revokeClientFailed": "无法撤销客户端访问权限",
  "connections.revokeClientFailedTitle": "无法撤销客户端访问权限",
  "connections.revokedOtherClients": "已撤销 {count} 个其他客户端",
  "connections.revokedOthersDescription": "其他已配对客户端需使用新的配对链接才能重新连接",
  "connections.revokeOthersFailed": "无法撤销其他客户端",
  "connections.revokeOthersFailedTitle": "无法撤销其他客户端",
  "connections.environmentConnected": "环境已连接",
  "connections.environmentReconnected": "环境已重新连接",
  "connections.sshReady": "{name} 已通过 SSH 托管隧道就绪",
  "connections.backendAddFailed": "无法添加后端",
  "connections.backendAddFailedTitle": "无法添加后端",
  "connections.backendAdded": "后端已添加",
  "connections.backendAddedDescription": "环境已保存，并会在应用启动时重新连接",
  "connections.backendConnectFailed": "无法连接后端",
  "connections.backendConnectFailedTitle": "无法连接后端",
  "connections.backendRemoveFailed": "无法移除后端",
  "connections.backendRemoveFailedTitle": "无法移除后端",
  "connections.host": "主机",
  "connections.sshHostOrAlias": "SSH 主机或别名",
  "connections.sshHostRequired": "请输入 SSH 主机或别名",
  "connections.sshPortInvalid": "SSH 端口必须在 1 到 65535 之间",
  "connections.backendHostRequired": "请输入后端主机",
  "connections.pairingCodeRequired": "请输入配对码",
  "connections.sshConnectFailed": "无法连接 SSH 主机",
  "connections.pastePairingUrl": "粘贴完整配对 URL，可自动填写这两个字段",
  "connections.username": "用户名",
  "connections.port": "端口",
  "connections.suggestedHosts": "建议主机",
  "connections.suggestedHostsDescription": "来自 SSH 配置和已知主机",
  "connections.noSshHosts": "未发现新的 SSH 主机",
  "connections.adding": "正在添加…",
  "connections.removing": "正在移除…",
  "connections.remove": "移除",
  "connections.connecting": "正在连接…",
  "connections.connect": "连接",
  "connections.disconnecting": "正在断开…",
  "connections.disconnect": "断开",
  "connections.setup": "设置",
  "connections.disable": "停用",
  "connections.hide": "隐藏",
  "connections.reachableAtLabel": "可访问地址",
  "connections.traceCopied": "已复制 Trace ID",
  "connections.copyTraceFailed": "无法复制 Trace ID",
  "connections.remoteLink": "远程链接",
  "connections.remoteLinkDescription": "输入后端主机和配对码",
  "connections.ssh": "SSH",
  "connections.sshDescription": "使用本地 SSH 配置、Agent 和隧道连接后端",
  "connections.noPairingClients": "暂无配对链接或客户端会话",
  "connections.wslUpdateFailed": "无法更新 WSL 后端",
  "connections.wslUpdateFailedTitle": "无法更改 WSL 后端",
  "connections.hostedAppLink": "托管应用链接",
  "connections.backendPairingUrl": "后端配对 URL",
  "connections.hostedLinkCopied": "已复制托管应用链接",
  "connections.pairingUrlCopied": "已复制配对 URL",
  "connections.pairingCodeCopied": "已复制配对码",
  "connections.openHostedLink": "请在要连接的设备上用浏览器打开",
  "connections.openPairingUrl": "请在要配对此环境的客户端中打开",
  "connections.pasteCode": "将其粘贴到其他客户端以完成配对",
  "connections.copyHostedFailed": "无法复制托管应用链接",
  "connections.copyPairingUrlFailed": "无法复制配对 URL",
  "connections.copyPairingCodeFailed": "无法复制配对码",
  "connections.clipboardUnavailable": "剪贴板复制不可用",
  "connections.showFullValue": "改为显示完整值",
  "connections.tokenOnly": "仅令牌",
  "connections.pairingUrls": "配对 URL",
  "provider.customHexColor": "自定义十六进制强调色",
  "provider.environmentVariableName": "环境变量名称 {index}",
  "provider.environmentVariableValue": "环境变量值 {index}",
  "provider.markVariableSensitive": "将环境变量 {name} 标记为敏感",
  "provider.removeEnvironmentVariable": "移除环境变量 {name}",
  "provider.checkingStatus": "正在检查 Provider 状态",
  "provider.waitingStatus": "正在等待服务器报告安装和认证详情",
  "provider.disabled": "已禁用",
  "provider.disabledDescription": "此 Provider 已安装，但已对 So Code 新会话禁用",
  "provider.notFound": "未找到",
  "provider.cliNotFound": "未在 PATH 中检测到 CLI",
  "provider.authenticated": "已认证",
  "provider.notAuthenticated": "未认证",
  "provider.needsAttention": "需要注意",
  "provider.couldNotVerify": "Provider 已安装，但服务器无法完全验证它",
  "provider.unavailable": "不可用",
  "provider.startupCheckFailed": "Provider 未通过启动检查",
  "provider.incompatible": "版本不兼容",
  "provider.incompatibleDescription": "Provider 运行时与所需 helper 的版本或能力不匹配",
  "provider.available": "可用",
  "provider.authCouldNotVerify": "已安装并就绪，但无法验证认证状态",
  "provider.updateAvailableInstall": "有可用更新：安装 {version}",
  "provider.updateAvailableLatest": "有可用更新：安装最新 Provider 版本",
  "webMisc.expandedImagePreview": "放大的图片预览",
  "webMisc.closeImagePreview": "关闭图片预览",
  "webMisc.previousImage": "上一张图片",
  "webMisc.nextImage": "下一张图片",
  "webMisc.unableToUpdatePreview": "无法更新弹出式预览",
  "webMisc.anErrorOccurred": "发生错误",
  "webMisc.floatingBrowserPreview": "浮动浏览器预览",
  "webMisc.openPreviewInRightPanel": "在右侧面板打开预览",
  "webMisc.closePoppedOutPreview": "关闭弹出式预览",
  "webMisc.popPreviewOut": "在独立窗口中打开预览",
  "webMisc.closeSeparateWindow": "关闭独立窗口",
  "webMisc.popIntoSeparateWindow": "移至独立窗口",
  "webMisc.closeFloatingPreview": "关闭浮动预览",
  "webMisc.resizeFloatingPreview": "调整浮动预览大小",
  "webMisc.on": "开启",
  "webMisc.off": "关闭",
  "webMisc.pushNotifications": "推送通知",
  "webMisc.liveActivities": "实时活动",
  "webMisc.loadingMobileClients": "正在加载移动端客户端",
  "webMisc.noMobileClients": "没有移动端客户端",
  "webMisc.noMobileClientsDetail": "请在 iPhone 上登录 So Code 以注册推送通知和实时活动",
  "webMisc.mobileClients": "移动端客户端",
  "webMisc.mobileClientsDetail": "已注册为接收环境中 T3 Connect 活动的设备",
  "webMisc.refresh": "刷新",
  "webMisc.couldNotLoadMobileClients": "无法加载移动端客户端",
  "webMisc.signInToT3Connect": "登录 T3 Connect",
  "webMisc.scriptNameRequired": "必须填写名称",
  "webMisc.scriptCommandRequired": "必须填写命令",
  "webMisc.failedToSaveAction": "无法保存操作",
  "webMisc.failedToImportAction": "无法导入操作",
  "webMisc.localBackendUnavailable": "配对后端前，本地后端 API 不可用",
  "webMisc.unableToOpenLink": "无法打开链接",
  "webMisc.localApiNotFound": "未找到本地 API",
  "fileBrowser.copyMention": "复制引用",
  "fileBrowser.addToChat": "添加到聊天",
  "fileBrowser.mentionCopied": "已复制引用",
  "fileBrowser.copyMentionFailed": "无法复制引用",
  "fileBrowser.addToChatFailed": "无法添加到聊天",
  "fileBrowser.openChatFirst": "请先打开此项目的聊天，然后重试",
  "fileBrowser.chatNotReady": "聊天当前无法接收输入",
  "fileBrowser.indexing": "正在建立索引…",
  "fileBrowser.search": "搜索工作区文件",
  "fileBrowser.refresh": "刷新工作区文件",
  "diff.workingTree": "工作树",
  "diff.branchChanges": "分支更改",
  "diff.latestTurn": "最新轮次",
  "diff.turn": "第 {count} 轮",
  "diff.turnLabel": "轮次",
  "diff.scope": "差异范围：{scope}",
  "diff.comparing": "比较 {head} 与 {base}",
  "diff.changeTarget": "更改比较目标，当前为 {target}",
  "diff.searchRefs": "搜索引用…",
  "diff.branch": "分支",
  "diff.remote": "远程",
  "diff.noMatchingRefs": "没有匹配的引用",
  "diff.automatic": "自动",
  "diff.useRemote": "使用 {name} 的远程版本",
  "diff.remoteOnly": "仅远程",
  "diff.expandAllFiles": "展开所有文件",
  "diff.collapseAllFiles": "折叠所有文件",
  "diff.stackedView": "堆叠差异视图",
  "diff.splitView": "并排差异视图",
  "diff.disableLineWrapping": "关闭自动换行",
  "diff.enableLineWrapping": "启用自动换行",
  "diff.showWhitespaceChanges": "显示空白字符更改",
  "diff.hideWhitespaceChanges": "隐藏空白字符更改",
  "diff.selectThread": "选择任务以查看轮次差异",
  "diff.notGitRepository": "此项目不是 Git 仓库，无法查看轮次差异",
  "diff.noCompletedTurns": "暂无已完成轮次",
  "diff.truncated": "差异超出预览限制，当前显示的更改不完整",
  "diff.loadingCheckpoint": "正在加载检查点差异…",
  "diff.loadingWorkingTree": "正在加载工作树差异…",
  "diff.loadingBranch": "正在加载分支差异…",
  "diff.noNetChanges": "当前选择没有实际更改",
  "diff.noPatch": "当前选择没有可用补丁",
  "diff.expandFile": "展开 {path}",
  "diff.collapseFile": "折叠 {path}",
  "diff.expandDiff": "展开差异",
  "diff.collapseDiff": "折叠差异",
  "scripts.fromT3Json": "来自 t3.json",
  "scripts.import": "导入",
  "scripts.groupLabel": "项目操作",
  "scripts.run": "运行 {name}",
  "scripts.actions": "脚本操作",
  "scripts.setupSuffix": "{name}（初始化）",
  "scripts.edit": "编辑 {name}",
  "scripts.addAction": "添加操作",
  "scripts.projectActions": "项目操作",
  "scripts.editAction": "编辑操作",
  "scripts.addActionTitle": "添加操作",
  "scripts.description": "操作是项目范围内的命令，可从顶部栏或快捷键运行",
  "scripts.name": "名称",
  "scripts.chooseIcon": "选择图标",
  "scripts.namePlaceholder": "测试",
  "scripts.keybinding": "快捷键",
  "scripts.keybindingPlaceholder": "按下快捷键",
  "scripts.keybindingHelp": "按下快捷键，使用 Backspace 清除",
  "scripts.command": "命令",
  "scripts.previewUrl": "预览 URL（可选）",
  "scripts.previewHelp": "此操作运行时在应用内预览中打开该 URL",
  "scripts.runOnWorktreeCreate": "创建工作树时自动运行",
  "scripts.autoOpenPreview": "运行此操作时自动打开预览",
  "scripts.saveChanges": "保存更改",
  "scripts.saveAction": "保存操作",
  "scripts.deleteTitle": "要删除操作“{name}”吗？",
  "scripts.deleteDescription": "此操作无法撤销",
  "scripts.deleteAction": "删除操作",
  "scripts.icon.play": "运行",
  "scripts.icon.test": "测试",
  "scripts.icon.lint": "检查",
  "scripts.icon.configure": "配置",
  "scripts.icon.build": "构建",
  "scripts.icon.debug": "调试",
} as const;

const systemLocale =
  typeof navigator === "undefined"
    ? Intl.DateTimeFormat().resolvedOptions().locale
    : navigator.languages.length > 0
      ? navigator.languages
      : navigator.language;

export function createWebI18n(locale: string | ReadonlyArray<string>) {
  return createI18n({
    locale: resolveLocale(locale),
    fallbackMessages,
    messages: { "zh-CN": zhCNMessages },
  });
}

export const i18n = createWebI18n(systemLocale);
